const messages: Record<string, string> = {
  'app.welcome': 'Bienvenido',
  'app.chat.placeholder': 'Escribe un mensaje...',
  'app.chat.send': 'Enviar',
  'app.chat.attach': 'Adjuntar archivo',
  'app.connection.status.connected': 'Conectado',
  'app.connection.status.disconnected': 'Desconectado',

  // Common
  'common.warning': 'Advertencia',
  'common.selectDate': 'Seleccionar Fecha',
  'common.noResults': 'No se encontraron resultados.',
  'common.status': 'Estado',
  'common.select': 'Seleccionar',
  'common.update': 'Actualizar',
  'common.success': 'Éxito',
  'common.confirmation.saveChanges': '¿Estás seguro de que deseas guardar estos cambios?',
  'common.confirmation': 'Confirmación',
  'common.actions': 'Acciones',
  'common.loading': 'Cargando...',
  'common.confirm': 'Confirmar',
  'common.cancel': 'Cancelar',
  'common.continue': 'Continuar',
  'common.custom': 'Personalizada',
  'cycle.template.banner':
    'Las plantillas son reutilizables. No tienen fecha de inicio — eso se elige cuando asignás la plantilla a un cliente.',
  'common.delete': 'Eliminar',
  'common.showing': 'Mostrando',
  'common.of': 'de',
  'common.template': 'Plantilla',
  'common.useAsTemplate': 'Usar como Plantilla',
  'common.edit': 'Editar',
  'common.save': 'Guardar',
  'common.saveAll': 'Guardar Todo',
  'common.copy': 'Copiar',
  'common.close': 'Cerrar',
  'common.search': 'Buscar',
  'common.filter': 'Filtrar',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.noData': 'No hay datos disponibles',
  'common.back': 'Atrás',
  'common.next': 'Siguiente',
  'common.errorSavingChanges': 'Error al guardar los cambios',
  'common.error': 'Error',
  'common.errorVerifyingChanges': 'Error al verificar los cambios',
  'common.errorNameRequired': 'El nombre del plan es requerido',
  'common.add': 'Agregar',
  'common.assign': 'Asignar',
  'common.unassign': 'Desasignar',
  'common.create': 'Crear',
  'common.createNew': 'Crear Nuevo',
  'common.missingData': 'Faltan datos',
  'common.completedOn': 'Completado el',
  'common.sessionTime': 'Horario de sesión',
  'common.feedback': 'Retroalimentación',
  'common.mood': 'Estado de ánimo',
  'common.energyLevel': 'Nivel de energía',
  'common.perceivedDifficulty': 'Dificultad percibida',
  'common.extraNotes': 'Notas adicionales',
  'common.group': 'Grupo',
  'common.days': 'Días',
  'common.day': 'Día',
  'common.week': 'Semana',
  'common.cycle': 'Ciclo',
  'common.selectCycle': 'Seleccionar Ciclo',
  'common.age': 'Edad',
  'common.years': 'años',
  'common.months': 'meses',
  'common.weeks': 'semanas',
  'common.workoutsPerWeek': 'entrenamientos por semana',
  'common.startDate': 'Fecha de Inicio',
  'common.endDate': 'Fecha de Fin',
  'common.comingSoon': 'Próximamente',
  'common.all': 'Todos',
  'common.location': 'Ubicación',
  'common.contactMethod': 'Método de Contacto',
  'common.notes': 'Notas',
  'home.success.checkEmail': '¡Revisa tu correo para continuar!',
  'common.selectContactMethod': 'Seleccionar Método de Contacto',
  'common.trainingType': 'Tipo de Entrenamiento',
  'common.selectTrainingType': 'Seleccionar Tipo de Entrenamiento',
  // Mensajes de confirmacion
  'assignPlan.confirmation.message': '¿Estás seguro de que deseas asignar este plan?',
  'assignPlan.success': 'Plan asignado exitosamente',
  'assignSubscription.confirmation.message': '¿Estás seguro de que deseas generar una suscripción para este cliente?',
  'createCycle.confirmation.message': '¿Estás seguro de que deseas crear este plan?',
  'deletePlan.confirmation.message': '¿Estás seguro de que deseas eliminar este plan?',
  'deleteStudent.confirmation.message': '¿Estás seguro de que deseas eliminar este estudiante?',
  'registerPayment.confirmation.message':
    '¿Estás seguro de que deseas registrar este pago y actualizar la suscripción del cliente?',

  'deleteExercise.confirmation.message': '¿Estás seguro de que deseas eliminar este ejercicio?',
  'createExercise.confirmation.message': '¿Estás seguro de que deseas crear este ejercicio?',
  'updateExercise.confirmation.message': '¿Estás seguro de que deseas actualizar este ejercicio?',
  'coach.plan.confirm.create': '¿Estás seguro de que deseas crear este plan?',
  'coach.plan.confirm.update': '¿Estás seguro de que deseas actualizar este plan?',
  'coach.plan.confirm.delete': '¿Estás seguro de que deseas eliminar este plan?',
  'coach.workout.confirm.delete': '¿Estás seguro de que deseas eliminar este entrenamiento?',
  'coach.exercise.confirm.upload': '¿Estás seguro de que deseas subir {rowsCount} ejercicios?',
  'coach.rpe.confirm.delete': '¿Estás seguro de que deseas eliminar este método de medición?',
  'coach.rpe.success.created': 'Método de medición creado exitosamente',
  'coach.rpe.success.updated': 'Método de medición actualizado exitosamente',
  'coach.rpe.success.deleted': 'Método de medición eliminado exitosamente',
  'coach.rpe.error.deleted': 'No se pudo eliminar el método de medición',
  'coach.rpe.success.defaultChanged': 'Método por defecto actualizado exitosamente',
  'coach.rpe.confirm.assign': '¿Estás seguro de que deseas asignar {rpe} al {type} seleccionado?',
  'coach.plan.confirm.clear': '¿Estás seguro de que deseas limpiar el plan de entrenamiento?',
  'coach.subscription.confirm.delete': '¿Estás seguro de que deseas eliminar la suscripción de este cliente?',
  'coach.subscription.success.deleted': 'Suscripción eliminada exitosamente',
  'coach.workoutsPerWeek': 'Entrenamientos por semana',
  'coach.exercise.upload.success': 'Ejercicios subidos',
  'coach.exercise.upload.duplicated': 'Ejercicios duplicados',
  'coach.exercise.selectType': 'Seleccionar Tipo de Ejercicio',
  'coach.rpe.assign.type': 'Seleccionar Tipo de Asignación',
  'coach.rpe.assign.rpe': 'Seleccionar RPE',

  // Mensajes para NewCoachHome
  'welcome.back': '¡Bienvenido de nuevo, {name}!',
  'stats.totalClients': 'Clientes Totales',
  'stats.activePlans': 'Planes Activos',
  'stats.upcomingSessions': 'Próximas Sesiones',
  'clients.title': 'Clientes',
  'clients.search': 'Buscar clientes...',
  'clients.noClientsFound': 'No se encontraron clientes.',
  'clients.completed': 'Completado',
  'clients.pending': 'Pendiente',
  'clients.expired': 'Expirado',
  'trainingPlans.title': 'Sesiones de Entrenamiento',
  'trainingPlans.newPlan': 'Nuevo Plan',
  'trainingPlans.editPlan': 'Editar Plan',
  'recentActivity.title': 'Actividad Reciente',
  'messages.title': 'Mensajes Recientes',
  'messages.openChat': 'Abrir Chat',
  'workoutProgress.title': 'Progreso de Entrenamientos',
  'subscription.title': 'Estado de Suscripción',
  'subscription.currentPlan': 'Plan Actual: Premium',
  'subscription.clientsManaged': 'Clientes Gestionados: {current}/{total}',
  'subscription.upgradePlan': 'Mejorar Plan',
  'upcomingSessions.title': 'Próximas Sesiones',
  'upcomingSessions.noSession': 'Sin sesiones próximas',
  // NewClientDashboard
  'clientDashboard.title': 'Panel del Cliente',
  'clientDashboard.tabs.calendar': 'Calendario de Entrenamientos',
  'clientDashboard.tabs.details': 'Detalles de Entrenamientos',
  'clientDashboard.tabs.excelView': 'Vista Excel',
  'clientDashboard.tabs.dashboard': 'Panel',
  'clientDashboard.tabs.workouts': 'Entrenamientos',
  'clientDashboard.tabs.progress': 'Progreso',
  'clientDashboard.tabs.settings': 'Configuraciones',
  'clientDashboard.tabs.profile': 'Perfil',
  'clientDashboard.tabs.clients': 'Clientes',
  'clientDashboard.tabs.payments': 'Pagos',
  'clientDashboard.tabs.medicalHistory': 'Historial Médico',
  'clientDashboard.tabs.userData': 'Datos del Usuario',

  'clientDashboard.buttons.assign': 'Asignar Entrenamientos',
  'clientDashboard.buttons.unassign': 'Eliminar sesiones/ciclos',
  'clientDashboard.buttons.createCycle': 'Crear Ciclo',
  'clientDashboard.buttons.assignCycleTemplate': 'Asignar Plantilla de Ciclo',
  'clientDashboard.addSession': 'Agregar sesión',
  'clientDashboard.success': 'Éxito',
  'clientDashboard.success.cycleAssigned': 'Ciclo de entrenamiento asignado exitosamente.',
  'clientDashboard.error.selectCycleAndDates': 'Por favor seleccione un ciclo de entrenamiento y fechas de inicio/fin.',
  'clientDashboard.assignCycleTemplate.dialog.header': 'Asignar Plantilla de Ciclo de Entrenamiento',
  'clientDashboard.assignCycleTemplate.selectCycle': 'Seleccionar Ciclo de Entrenamiento',
  'clientDashboard.assignCycleTemplate.selectCyclePlaceholder': 'Seleccionar un ciclo de entrenamiento',
  'clientDashboard.comingSoon.dashboard': 'Estamos trabajando en un panel con estadísticas y métricas de progreso.',
  'clientDashboard.comingSoon.medicalHistory': 'Pronto podrás gestionar el historial médico de tus clientes.',
  'clientDashboard.comingSoon.userData': 'Pronto podrás ver y editar todos los datos del usuario desde aquí.',

  'clientDashboard.workout.completedOn': 'Completado el',
  'clientDashboard.workout.sessionTime': 'Tiempo de sesión',
  'clientDashboard.workout.feedback': 'Comentarios',
  'clientDashboard.workout.mood': 'Estado de ánimo',
  'clientDashboard.workout.energy': 'Nivel de energía',
  'clientDashboard.workout.difficulty': 'Dificultad',
  'clientDashboard.workout.notes': 'Notas adicionales',

  'clientDashboard.dropdown.selectWorkout': 'Seleccionar Entrenamiento',
  'clientDashboard.dropdown.selectExercise': 'Seleccionar Ejercicio',

  'clientDashboard.table.workoutName': 'Nombre del Entrenamiento',
  'clientDashboard.table.details': 'Detalles',
  'clientDashboard.table.set': 'Serie',
  'clientDashboard.table.type': 'Tipo',
  'clientDashboard.table.expected': 'Esperado',
  'clientDashboard.table.completed': 'Completado',
  'clientDashboard.showExcelOnly': 'Mostrar solo vista Excel',
  'clientDashboard.showFullDashboard': 'Mostrar dashboard completo',

  // NewClientProfile
  'profile.title': 'Perfil del Cliente',
  'profile.title.mine': 'Mi Perfil',
  'profile.today.title': 'Hoy',
  'profile.today.training': 'Entrenamiento de hoy',
  'profile.today.startTraining': 'Empezar entrenamiento',
  'profile.today.completed.title': '¡Felicitaciones! Ya terminaste tu entrenamiento del día',
  'profile.today.viewDetails': 'Ver detalles',
  'profile.today.restDay': 'Hoy es día de descanso',
  'profile.today.restSubtitle': 'Aprovechá para recuperarte',
  'profile.streak.title': 'Racha',
  'profile.streak.days': 'días seguidos',
  'profile.streak.startNow': '¡Empezá tu racha hoy!',
  'profile.subscription.daysLeft': '{days, plural, one {# día restante} other {# días restantes}}',
  'profile.subscription.expired': 'Vencida',
  'profile.subscription.none': 'No tenés un plan activo',
  'profile.coach.title': 'Tu Coach',
  'profile.coach.contact': 'Contactar',
  'profile.recentHistory': 'Historial Reciente',
  'profile.recentHistory.empty': 'Todavía no tenés entrenamientos registrados',
  'profile.toast.noData': 'No hay datos de perfil disponibles',
  'profile.toast.updated': 'Información personal actualizada correctamente',
  'profile.validation.fitnessGoal': 'El objetivo de fitness no puede estar vacío',
  'profile.validation.activityLevel': 'El nivel de actividad no puede estar vacío',
  'profile.personalInfo': 'Información Personal',
  'profile.name': 'Nombre',
  'profile.email': 'Correo electrónico',
  'profile.birthdate': 'Fecha de nacimiento',
  'profile.gender': 'Género',
  'profile.phone': 'Teléfono',
  'profile.edit': 'Editar',

  'profile.subscription': 'Suscripción Actual',
  'profile.subscription.planName': 'Nombre del Plan',
  'profile.subscription.startDate': 'Fecha de inicio',
  'profile.subscription.endDate': 'Fecha de fin',
  'profile.subscription.status': 'Estado',
  'profile.subscription.frequency': 'Modalidad',
  'profile.subscription.frequency.monthly': 'Mensual',
  'profile.subscription.frequency.weekly': 'Semanal',
  'profile.subscription.frequency.per_session': 'Por sesión',
  'profile.subscription.sessionsUsed': 'Sesiones realizadas',

  'profile.tabs.workoutHistory': 'Historial de Entrenamientos',
  'profile.tabs.progress': 'Progreso',
  'profile.tabs.activities': 'Actividades Históricas',

  'profile.table.planName': 'Nombre del Plan',
  'profile.table.details': 'Detalles',
  'profile.table.trainingDate': 'Fecha de Entrenamiento',
  'profile.table.dayTrained': 'Día Entrenado',
  'profile.table.status': 'Estado',
  'profile.table.date': 'Fecha',
  'profile.table.action': 'Acción',
  'profile.table.week': 'Semana {number}',
  'profile.table.day': 'Día {number}',

  'profile.dialog.edit': 'Editar Información Personal',
  'profile.dialog.fitnessGoal': 'Objetivo de Fitness',
  'profile.dialog.activityLevel': 'Nivel de Actividad',
  'profile.dialog.cancel': 'Cancelar',
  'profile.dialog.save': 'Guardar',

  'profile.goals.weightLoss': 'Pérdida de peso',
  'profile.goals.muscleGain': 'Ganancia muscular',
  'profile.goals.mobility': 'Ganar movilidad',
  'profile.goals.maintenance': 'Mantenimiento',
  'profile.goals.flexibility': 'Flexibilidad',

  'profile.activity.sedentary': 'Sedentario',
  'profile.activity.moderate': 'Moderadamente activo',
  'profile.activity.active': 'Muy activo',

  'fitnessGoal.custom': 'Objetivo Fitness Personalizado',

  // NewCoachProfile
  'coach.welcome': 'Bienvenido, {name}!',
  'coach.email': 'Correo',
  'coach.experience': 'Experiencia',
  'coach.trainingType': 'Tipo de Entrenamiento',
  'coach.gymLocation': 'Ubicación del Gimnasio',
  'coach.biography': 'Biografía',

  'coach.tabs.workouts': 'Entrenamientos',
  'coach.tabs.plans': 'Mis Servicios',
  'coach.tabs.exercises': 'Ejercicios',
  'coach.tabs.subscription': 'Planes de Suscripción',
  'coach.tabs.rpe': 'Medición de Carga Subjetiva',
  'coach.tabs.clients': 'Clientes',

  'coach.workouts.title': 'Entrenamientos',
  'coach.workout.details': 'Detalles del Entrenamiento',
  'coach.workout.success.deleted.message': 'Entrenamiento eliminado exitosamente!',
  'coach.workout.success.assigned.message': 'Entrenamiento asignado exitosamente!',
  'coach.workout.success.unassigned.message': 'Entrenamiento desasignado exitosamente!',
  'coach.workout.error.selectWorkoutAndDay':
    'Por favor, selecciona un entrenamiento y un día de la semana para la última asignación.',
  'coach.workout.error.selectAtLeastOneWorkout': 'Por favor, selecciona al menos un entrenamiento.',

  // NewCreatePlan
  'coach.createPlan.title': 'Crear Plan de Entrenamiento',
  'coach.createPlan.subtitle': 'Crea un plan de entrenamiento personalizado para tus clientes',
  'coach.createPlan.description': 'Usa esta página para crear un plan de entrenamiento personalizado para tus clientes',
  'coach.createPlan.name': 'Nombre del Plan',
  'coach.createPlan.duration': 'Duración (semanas)',
  'coach.createPlan.workoutsPerWeek': 'Entrenamientos por semana',
  'coach.createPlan.startDate': 'Fecha de inicio',
  'coach.createPlan.endDate': 'Fecha de fin',
  'coach.createPlan.workouts': 'Entrenamientos',
  'coach.createPlan.addWorkout': 'Agregar Entrenamiento',
  'coach.createPlan.save': 'Guardar Plan',
  'coach.createPlan.cancel': 'Cancelar',
  'coach.createPlan.success': 'Plan creado exitosamente',
  'coach.createPlan.error': 'Error al crear el plan',
  'coach.createPlan.error.nameRequired': 'El nombre del plan es requerido',
  'coach.createPlan.error.descriptionRequired': 'La descripción del plan es requerida',
  'coach.createPlan.error.durationRequired': 'La duración del plan es requerida',
  'coach.createPlan.error.workoutsPerWeekRequired': 'El número de entrenamientos por semana es requerido',
  'coach.createPlan.error.startDateRequired': 'La fecha de inicio es requerida',
  'coach.createPlan.error.endDateRequired': 'La fecha de fin es requerida',
  'coach.createPlan.error.workoutsRequired': 'Debes agregar al menos un entrenamiento al plan',
  'coach.createPlan.error.invalidDates': 'La fecha de fin debe ser posterior a la fecha de inicio',
  'coach.createPlan.error.invalidDuration': 'La duración debe ser mayor a 0',
  'coach.createPlan.error.invalidWorkoutsPerWeek': 'El número de entrenamientos por semana debe ser mayor a 0',
  'coach.createPlan.error.invalidWorkoutsCount':
    'El número de entrenamientos debe ser igual al número de entrenamientos por semana',
  'coach.createPlan.error.invalidWorkoutName': 'El nombre del entrenamiento es requerido',
  'coach.createPlan.error.invalidWorkoutDescription': 'La descripción del entrenamiento es requerida',
  'coach.createPlan.error.invalidWorkoutExercises': 'Debes agregar al menos un ejercicio al entrenamiento',
  'coach.createPlan.error.invalidExerciseName': 'El nombre del ejercicio es requerido',
  'coach.createPlan.error.invalidExerciseSets': 'El número de series es requerido',
  'coach.createPlan.error.invalidExerciseReps': 'El número de repeticiones es requerido',
  'coach.createPlan.error.invalidExerciseWeight': 'El peso es requerido',
  'coach.createPlan.error.invalidExerciseRest': 'El tiempo de descanso es requerido',
  'coach.createPlan.error.invalidExerciseNotes': 'Las notas son requeridas',
  'coach.createPlan.error.invalidExerciseRPE': 'El RPE es requerido',
  'coach.createPlan.error.invalidExerciseType': 'El tipo de ejercicio es requerido',
  'coach.createPlan.error.invalidExerciseMuscleGroup': 'El grupo muscular es requerido',
  'coach.createPlan.error.invalidExerciseEquipment': 'El equipo es requerido',
  'coach.createPlan.error.invalidExerciseDifficulty': 'La dificultad es requerida',
  'coach.createPlan.error.invalidExerciseVideo': 'El video es requerido',
  'coach.createPlan.error.invalidExerciseImage': 'La imagen es requerida',
  'coach.createPlan.error.invalidExerciseInstructions': 'Las instrucciones son requeridas',
  'coach.createPlan.error.invalidExerciseTips': 'Los consejos son requeridos',
  'coach.createPlan.error.invalidExerciseCommonMistakes': 'Los errores comunes son requeridos',
  'coach.createPlan.error.invalidExerciseVariations': 'Las variaciones son requeridas',
  'coach.createPlan.error.invalidExerciseProgression': 'La progresión es requerida',
  'coach.createPlan.error.invalidExerciseRegression': 'La regresión es requerida',
  'coach.createPlan.error.invalidExerciseScaling': 'El escalado es requerido',
  'coach.createPlan.error.invalidExerciseModifications': 'Las modificaciones son requeridas',
  'coach.createPlan.error.invalidExerciseAlternatives': 'Las alternativas son requeridas',
  'createPlan.unsavedChanges.message': 'Tenés cambios sin guardar. ¿Estás seguro de que querés salir?',

  // NewCoachProfile
  'coach.createPlan.buttons.add': 'Agregar {item}',
  'coach.createPlan.buttons.assign': 'Asignar {item}',
  'coach.createPlan.buttons.import': 'Importar Ejercicios',
  'coach.createPlan.buttons.save': 'Guardar Plan',
  'coach.createPlan.buttons.cancel': 'Cancelar',
  'coach.createPlan.buttons.delete': 'Eliminar',
  'coach.createPlan.buttons.edit': 'Editar',
  'coach.createPlan.buttons.addGroup': 'Agregar Grupo',
  'coach.createPlan.buttons.addExercise': 'Agregar Ejercicio',
  'coach.createPlan.buttons.addRestPeriod': 'Agregar Período de Descanso',
  'coach.createPlan.buttons.addRestPeriod.label': 'Período de Descanso (segundos)',
  'coach.createPlan.buttons.restPeriod.label': 'Período de Descanso',
  'coach.delete.confirmation': '¿Estás seguro de que deseas eliminar este plan?',
  'coach.delete.header': 'Confirmar Eliminación',
  'coach.delete.error.referenced': 'Error',
  'coach.delete.error.referenced.detail': 'Este plan de entrenamiento está siendo utilizado por un cliente',
  'coach.delete.error.generic': 'Error',

  'coach.rpe.name': 'Nombre',
  'coach.rpe.minValue': 'Valor Mínimo',
  'coach.rpe.maxValue': 'Valor Máximo',
  'coach.rpe.step': 'Paso',
  'coach.rpe.valuesMeta': 'Valores Meta',
  'coach.rpe.addValue': 'Agregar Valor',
  'coach.rpe.selectType': 'Seleccionar Tipo de Asignación',
  'coach.rpe.create': 'Crear Método de Medición',
  'coach.rpe.update': 'Actualizar Método de Medición',
  'coach.rpe.methods': 'Métodos de Medición Subjetiva',
  'coach.rpe.assignments': 'Asignaciones de Medición Subjetiva',
  'coach.rpe.method': 'Método de Medición Subjetiva',
  'coach.rpe.targetType': 'Tipo de destino',
  'coach.rpe.targetName': 'Nombre del destino',
  'coach.rpe.confirm.removeAssignment': '¿Estás seguro de que deseas eliminar esta asignación de Medición Subjetiva?',

  'coach.subscription.currentPlan': 'Plan Actual',
  'coach.subscription.maxClients': 'Clientes Máximos: {max}',

  'coach.exercise.dragDrop': 'Arrastra y suelta un archivo aquí para subir.',
  'coach.exercise.name': 'Nombre del Ejercicio',
  'coach.exercise.type': 'Tipo',
  'coach.exercise.description': 'Descripción',
  'coach.exercise.equipment': 'Equipamiento Necesario',
  'coach.exercise.video': 'Video',
  'coach.exercise.bodyArea': 'Área corporal involucrada',
  'coach.exercise.create': 'Crear Ejercicio',
  'coach.exercise.edit': 'Editar Ejercicio',
  'coach.exercise.error.name.empty': 'El nombre del ejercicio no puede estar vacío.',
  'coach.exercise.error.video.invalid': 'Por favor ingresa una URL válida de YouTube',
  'coach.exercise.error.video.invalid.message': 'Por favor ingresa una URL válida de YouTube',
  'coach.exercise.error.video.invalid.header': 'Error',

  // NewManageStudents
  'students.title': 'Tus entrenados',
  'students.subtitle': 'Ver y gestionar el progreso de tus entrenados',
  'students.description':
    'Usa esta página para seguir el progreso de tus entrenados, asignar sesiones de entrenamiento y comunicarte directamente con ellos.',

  'students.search': 'Buscar estudiantes',
  'editor.groupType.label': 'Tipo',
  'editor.groupType.standard': 'Estándar',
  'editor.groupType.rest': 'Descanso',
  'editor.groupType.superset': 'Superset',
  'editor.groupType.circuit': 'Circuito',
  'editor.groupType.tabata': 'Tabata',
  'editor.groupType.emom': 'EMOM',
  'editor.groupType.amrap': 'AMRAP',
  'editor.groupType.workSeconds': 'Trabajo (s)',
  'editor.groupType.restSeconds': 'Descanso (s)',
  'editor.groupType.rounds': 'Rondas',
  'editor.groupType.interval': 'Intervalo (s)',
  'editor.groupType.totalRounds': 'Total rondas',
  'editor.groupType.totalSeconds': 'Total (s)',
  'students.addNew': 'Agregar Nuevo Estudiante',
  'students.noStudents': 'No se encontraron estudiantes.',

  'students.table.name': 'Nombre',
  'students.table.email': 'Correo',
  'students.table.status': 'Estado',
  'students.table.lastPayment': 'Último Pago',
  'students.table.nextPayment': 'Próximo Pago',
  'students.table.plan': 'Plan de Suscripción',
  'students.table.actions': 'Acciones',

  'students.status.active': 'Activo',
  'students.status.inactive': 'Inactivo',

  'students.actions.viewProfile': 'Ver Perfil',
  'students.actions.registerPayment': 'Registrar Pago',
  'students.actions.deleteSubscription': 'Eliminar Suscripción',
  'students.actions.sendMessage': 'Enviar Mensaje',
  'students.actions.deleteClient': 'Eliminar Cliente',
  'students.actions.resendVerification': 'Reenviar Verificación',
  'students.actions.assignSubscription': 'Asignar Suscripción',
  'students.actions.editProfile': 'Editar Perfil',

  'students.dialog.newStudent': 'Nuevo Estudiante',
  'students.dialog.assignSubscription': 'Asignar Suscripción',
  'students.dialog.registerPayment': 'Registrar Pago',
  'students.dialog.studentDetails': 'Detalles del Estudiante',
  'students.dialog.editProfile': 'Editar Perfil',
  'students.dialog.editProfile.success': 'Perfil actualizado exitosamente!',
  'students.confirm.deleteSubscription': '¿Estás seguro que deseas eliminar la suscripción de este cliente?',
  'students.confirm.deleteClient': '¿Estás seguro que deseas eliminar este cliente?',
  'students.success.deleted': 'Cliente eliminado exitosamente!',
  'students.success.verificationSent': 'Email de verificación enviado exitosamente!',

  // NewStudentHome
  'studentHome.welcome': '¡Bienvenido, {name}!',
  'studentHome.streak.daily': 'Racha Diaria',
  'studentHome.streak.weekly': 'Racha Semanal',
  'studentHome.streak.days': 'días',
  'studentHome.streak.weeks': 'semanas',
  'studentHome.todayWorkouts': 'Entrenamientos de Hoy',
  'studentHome.noWorkoutsToday': 'No hay entrenamientos programados para hoy',
  'studentHome.viewWorkout': 'Ver Detalles',
  'studentHome.startWorkout': 'Comenzar Entrenamiento',
  'studentHome.viewCalendar': 'Ver Calendario Completo',
  'workout.status.pending': 'Pendiente',
  'workout.status.completed': 'Completado',
  'workout.status.expired': 'Expirado',
  'studentHome.dialog.planDetails': 'Detalles del Plan',
  'studentHome.noEvents': 'No hay sesiones de entrenamiento programadas',
  'studentHome.calendar.title': 'Calendario de Entrenamientos',
  'studentHome.calendar.filterMonth': 'Filtrar por mes',
  'studentHome.calendar.viewDetails': 'Ver detalles',
  'studentHome.calendar.startTraining': 'Comenzar Entrenamiento',

  // Meses (si no existen ya)
  'months.january': 'Enero',
  'months.february': 'Febrero',
  'months.march': 'Marzo',
  'months.april': 'Abril',
  'months.may': 'Mayo',
  'months.june': 'Junio',
  'months.july': 'Julio',
  'months.august': 'Agosto',
  'months.september': 'Septiembre',
  'months.october': 'Octubre',
  'months.november': 'Noviembre',
  'months.december': 'Diciembre',

  // Calendario
  'calendar.today': 'Hoy',
  'calendar.month': 'Mes',
  'calendar.week': 'Semana',
  'calendar.day': 'Día',
  'calendar.list': 'Lista',

  // Mensajes de error
  'error.fetchTraining': 'Error al cargar los datos de entrenamiento',

  // NewStudentsDetails
  'studentDetails.title': 'Detalles de {name}',
  'studentDetails.back': 'Volver',
  'studentDetails.loading': 'Cargando...',

  'studentDetails.personalInfo.title': 'Información Personal',
  'studentDetails.personalInfo.email': 'Correo',
  'studentDetails.personalInfo.fitnessGoal': 'Objetivo Fitness',
  'studentDetails.personalInfo.activityLevel': 'Nivel de Actividad',

  'studentDetails.activities.title': 'Actividades Recientes',
  'studentDetails.progress.title': 'Progreso',

  'studentDetails.plans.current': 'Sesiones de Entrenamiento Actuales',
  'studentDetails.plans.completed': 'Sesiones de Entrenamiento Completados',
  'studentDetails.plans.name': 'Nombre del Plan',
  'studentDetails.plans.description': 'Descripción',
  'studentDetails.plans.notes': 'Notas',
  'studentDetails.plans.startDate': 'Fecha de Inicio',
  'studentDetails.plans.endDate': 'Fecha de Fin',
  'studentDetails.plans.status': 'Estado',
  'studentDetails.plans.progress': 'Progreso',

  'studentDetails.dialog.planDetails': 'Detalles del Plan',
  'studentDetails.dialog.confirmDelete': '¿Estás seguro que deseas eliminar este plan?',
  'studentDetails.dialog.confirmDeleteHeader': 'Confirmar Eliminación',

  'studentDetails.success.planDeleted': '¡Has eliminado el plan {name} exitosamente!',
  'studentDetails.error.fetchData': 'Error al cargar los datos del estudiante',

  'studentDetails.tooltip.viewDetails': 'Ver Detalles',
  'studentDetails.tooltip.deletePlan': 'Eliminar Plan',

  // NewTrainingDetails
  'training.comments.placeholder': 'Escribe tus comentarios aquí...',
  'training.title': 'Plan de Entrenamiento',
  'training.status': 'Estado',
  'training.group': 'Grupo {number}',
  'training.setCount': 'Cantidad de Series',
  'training.restInterval': 'Intervalo de Descanso',
  'training.seconds': 'segundos',

  'training.exercise.details': 'Detalles del Ejercicio',
  'training.exercise.progress': 'Progreso del Ejercicio',
  'training.exercise.videoUrl': 'URL del Video',
  'training.exercise.set': 'Set',
  'training.exercise.reps': 'Reps',
  'training.exercise.weight': 'Peso ({unit})',
  'training.exercise.time': 'Tiempo ({unit})',
  'training.exercise.distance': 'Distancia ({unit})',
  'training.exercise.tempo': 'Tempo ({unit})',
  'training.exercise.difficulty': 'Dificultad ({unit})',
  'training.exercise.duration': 'Duración ({unit})',
  'training.exercise.completed': 'Completado',
  'training.exercise.sets': 'Series',

  'training.group.set': 'Series',
  'training.group.rest': 'Descanso',

  'training.comments': 'Comentarios',
  'training.buttons.saveProgress': 'Guardar Progreso',
  'training.buttons.exit': 'Salir del entrenamiento',
  'training.exit.title': '¿Salir del entrenamiento?',
  'training.exit.body':
    'Lo que marcaste queda guardado en este dispositivo y podés retomarlo cuando vuelvas. Pero la sesión no queda registrada hasta que la finalices.',
  'training.exit.keepTraining': 'Seguir entrenando',
  'training.exit.confirm': 'Salir igual',
  'training.buttons.finishTraining': 'Finalizar Entrenamiento',
  'training.success.saved': 'Progreso guardado exitosamente',
  'training.error.exerciseNotFound': 'Ejercicio no encontrado',
  'training.error.fillAllFields': 'Por favor complete todos los campos',
  'training.error.noFeedback': 'No hay feedback para enviar',
  'training.loading': 'Cargando...',

  'training.checkbox.completed': 'Completado',
  'training.checkbox.notAsPlanned': 'Completado No Según lo Planeado',
  'training.checkbox.readOnly': 'Solo Lectura',

  'training.session.finished': '¡Sesión finalizada!',
  'training.session.congrats': '¡Felicitaciones, has terminado tu rutina!',

  'training.property.repetitions': 'Repeticiones',
  'training.property.weight': 'Peso',
  'training.property.time': 'Tiempo',
  'training.property.distance': 'Distancia',
  'training.property.tempo': 'Tempo',
  'training.property.difficulty': 'Dificultad',
  'training.property.duration': 'Duración',
  'training.property.restInterval': 'Intervalo de Descanso',

  'training.dialog.finishTitle': 'Finalizar Entrenamiento',
  'training.dialog.videoTitle': 'Video del Ejercicio',

  'training.buttons.viewDetails': 'Ver Detalles',

  'training.success.finished': '¡Felicitaciones, has terminado tu rutina!',

  // TrainingDetails
  'training.group.title': 'Grupo {number}',

  'training.exercise.video': 'URL del Video',

  'training.exercise.comments': 'Comentarios',

  'training.plan.name': 'Nombre del Plan',
  'training.plan.status': 'Estado',

  'training.buttons.save': 'Guardar Progreso',
  'training.buttons.clearProgress': 'Limpiar Progreso',
  'training.buttons.finish': 'Finalizar Entrenamiento',

  'training.error.fillFields': 'Todos los campos relevantes deben estar completos.',

  // NewCreatePlan
  'plan.create.title': 'Crear Plan',
  'plan.edit.title': 'Editar Plan',
  'plan.name': 'Nombre del Plan',
  'plan.notes': 'Notas Personalizadas',

  'plan.buttons.import': 'Importar desde Imagen',
  'plan.buttons.addGroup': 'Agregar Grupo',
  'plan.buttons.undoDelete': 'Deshacer Eliminación',
  'plan.buttons.clearPlan': 'Limpiar Plan',
  'plan.buttons.createPlan': 'Crear Plan',
  'plan.buttons.editPlan': 'Editar Plan',

  'plan.group.title': 'Grupo {number}',
  'plan.group.restPeriod': 'Descanso',
  'plan.group.isRestPeriod': 'Es Descanso',
  'plan.group.addRest': 'Agregar Descanso',
  'plan.group.restDuration': 'Duración del Descanso (segundos)',
  'plan.group.restDurationRequired': 'La duración del descanso es requerida.',
  'plan.group.seconds': 'segundos',
  'plan.group.addGroup': 'Agregar Grupo',
  'plan.group.name': 'Nombre del Grupo',
  'plan.group.set': 'Serie',
  'plan.group.rest': 'Descanso (segundos)',
  'plan.group.addExercise': 'Agregar Ejercicio',
  'plan.group.removed': 'Grupo Eliminado',
  'plan.group.removed.message.number': 'El grupo número {number} ha sido eliminado',
  'plan.group.removed.message.name': 'El grupo "{name}" ha sido eliminado',
  'plan.group.empty': 'Arrastra ejercicios aquí para agregarlos al grupo.',
  'plan.group.empty.notDraggable': 'No hay ejercicios en este grupo',
  'plan.group.restDurationSuffix': ' segundos',
  'plan.exercise.select': 'Seleccionar un Ejercicio',
  'plan.exercise.add': 'Agregar Ejercicio',
  'plan.exercise.notes': 'Notas',
  'plan.exercise.property.add': 'Agregar Propiedad',

  'plan.dialog.confirmClear': '¿Estás seguro que deseas limpiar todo el plan de entrenamiento?',
  'plan.dialog.confirmCreate': '¿Estás seguro que deseas crear este plan?',
  'plan.dialog.confirmEdit': '¿Estás seguro que deseas editar este plan?',

  'plan.success.created': '¡Has creado el plan {name} exitosamente!',
  'plan.success.updated': '¡Has actualizado el plan {name} exitosamente!',
  'plan.success.imported': 'El plan de entrenamiento ha sido importado desde la imagen exitosamente.',

  'plan.error.nameRequired': 'El nombre del plan es requerido.',
  'plan.error.groupRequired': 'Se requiere al menos un grupo.',
  'plan.error.exerciseRequired': 'Cada grupo debe tener al menos un ejercicio.',
  'plan.error.exerciseSelect': 'Cada ejercicio debe estar seleccionado. {name} no está seleccionado.',

  // Traducciones adicionales

  // Propiedades de ejercicios
  'exercise.properties.sets': 'Series',
  'exercise.properties.reps': 'Repeticiones',
  'exercise.properties.time': 'Tiempo',
  'exercise.properties.weight': 'Peso',
  'exercise.properties.restInterval': 'Intervalo de Descanso',
  'exercise.properties.tempo': 'Tempo',
  'exercise.properties.difficulty': 'Dificultad',
  'exercise.properties.duration': 'Duración',
  'exercise.properties.distance': 'Distancia',
  'exercise.properties.height': 'Altura',
  'exercise.properties.restPeriod': 'Intervalo de Descanso',
  'exercise.properties.notes': 'Notas',
  'exercise.properties.perceivedDifficulty': 'Dificultad Percibida',
  'exercise.properties.mood': 'Estado de Ánimo',
  'exercise.properties.energyLevel': 'Nivel de Energía',
  'exercise.properties.extraNotes': 'Notas Adicionales',
  'exercise.properties.generalFeedback': 'Retroalimentación General',
  'exercise.properties.realEndDate': 'Fecha de Finalización Real',
  'exercise.properties.sessionTime': 'Tiempo de Sesión',
  'exercise.properties.completed': 'Completado',
  'exercise.properties.notCompleted': 'No Completado',
  'exercise.properties.completedNotAsPlanned': 'No Completado Según lo Planeado',
  'exercise.properties.comments': 'Comentarios',
  'exercise.properties.setLogs': 'Registro de Series',
  'exercise.properties.restDuration': 'Duración del Descanso (segundos)',
  'exercise.setConfiguration.title': 'Configuración de Sets',
  'exercise.feedback.title': 'Feedback del Cliente',
  // Mensajes de confirmación
  'confirm.delete': '¿Estás seguro que deseas eliminar esto?',
  'confirm.deleteGroup': '¿Estás seguro que deseas eliminar este grupo?',
  'confirm.header': 'Confirmar Acción',

  // Mensajes de éxito/error
  'success.saved': 'Guardado exitosamente',
  'success.deleted': 'Eliminado exitosamente',
  'success.updated': 'Actualizado exitosamente',
  'error.generic': 'Algo salió mal',
  'error.required': 'Este campo es requerido',

  // Tooltips
  'tooltip.addExercise': 'Agregar ejercicio',
  'tooltip.removeExercise': 'Eliminar ejercicio',
  'tooltip.addProperty': 'Agregar propiedad',
  'tooltip.removeProperty': 'Eliminar propiedad',
  'tooltip.dragGroup': 'Arrastrar para reordenar',
  'tooltip.hoverForOptions': 'Opciones disponibles',

  // Filtros y ordenamiento
  'filter.byName': 'Filtrar por nombre',
  'filter.byType': 'Filtrar por tipo',
  'sort.ascending': 'Ascendente',
  'sort.descending': 'Descendente',

  // Coach Dashboard Widgets
  'dashboard.upcomingWorkouts': 'Próximos Entrenamientos',
  'dashboard.paymentDates': 'Fechas de Cobro',
  'dashboard.runningOut': 'Se Quedan Sin Entrenamientos',
  'dashboard.importantDates': 'Fechas Importantes',
  'dashboard.lastTrained': 'Últimos que Entrenaron',
  'dashboard.revenue': 'Ingresos',
  'dashboard.alerts': 'Alertas',
  'dashboard.trainedOnAnotherDay': '{person} hizo la sesión el {day}, aunque estaba programada para el {scheduledDay}',
  'dashboard.consistency': 'Constancia de Entrenamiento',
  'dashboard.today': 'Hoy',
  'dashboard.tomorrow': 'Mañana',
  'dashboard.yesterday': 'Ayer',
  'dashboard.session': 'Sesión',
  'dashboard.daysLeft': 'días',
  'dashboard.sessionsLeftLabel': 'sesiones',
  'dashboard.runsOutOn': 'Se queda sin entrenamientos el {date}',
  'dashboard.overdue': 'vencidos',
  'dashboard.noUpcoming': 'No hay entrenamientos próximos',
  'dashboard.noPaymentData': 'No hay datos de pagos',
  'dashboard.noCycleData': 'No hay datos de ciclos',
  'dashboard.noImportantDates': 'No hay fechas importantes',
  'dashboard.noTrainingData': 'No hay datos de entrenamiento',
  'dashboard.noRevenueData': 'No hay datos de ingresos',
  'dashboard.noFrequencyData': 'No hay datos de frecuencia',
  'dashboard.noAlerts': 'Todo en orden, no hay alertas',
  'dashboard.consistencyLast7Days': '% de sesiones completadas · últimos 7 días',
  'dashboard.sessionsLast7Days': 'sesiones últimos 7 días',
  'dashboard.lastMonths': 'últimos {count} meses',

  // NewClientDashboard - Adicionales
  'dashboard.calendar.viewDetails': 'Ver detalles del entrenamiento',
  'dashboard.calendar.assignWorkout': 'Asignar entrenamientos al día',
  'dashboard.calendar.assignWorkoutTo': 'Asignar entrenamiento',
  'clientDashboard.cycle.createNewCycle': 'Crear Nuevo Ciclo',
  'dashboard.table.set': 'Serie',
  'dashboard.table.type': 'Tipo',
  'dashboard.table.expected': 'Esperado',
  'dashboard.table.completed': 'Completado',

  'dashboard.exercise.status.completed': '✔',
  'dashboard.exercise.status.notCompleted': '✘',

  'dashboard.dialog.planDetails': 'Detalles del Plan',
  'plan.details.sessionInfo': 'Información de la sesión',
  'plan.details.editExercises': 'Editar ejercicios',

  'dashboard.chart.expectedReps': 'Repeticiones Esperadas',
  'dashboard.chart.completedReps': 'Repeticiones Completadas',
  'dashboard.chart.averageWeight': 'Peso Promedio (kg)',
  'dashboard.chart.averageRpe': 'RPE Promedio',

  'dashboard.calendar.today': 'Hoy',
  'dashboard.calendar.month': 'Mes',
  'dashboard.calendar.week': 'Semana',
  'dashboard.calendar.day': 'Día',
  'dashboard.calendar.list': 'Lista',

  // NewCoachHome - Adicionales
  'coach.home.trainingFrequencyChart': 'Gráfico de Frecuencia de Entrenamiento',
  'coach.home.noFrequencyData': 'Sin datos de frecuencia aún',
  'coach.home.clientsSummary': 'Resumen de Clientes',
  'coach.home.table.clientName': 'Cliente',
  'coach.home.table.lastWorkout': 'Último Entreno',
  'coach.home.table.daysLeft': 'Días Restantes',
  'coach.home.table.paymentStatus': 'Estado de Pago',
  'coach.home.table.totalSessions': 'Total de Sesiones',
  'coach.home.table.totalRevenue': 'Total de Ingresos',
  'coach.home.table.header': 'Otra Sección',
  'coach.home.table.last30days': 'Últimos 30 Días',
  'coach.home.table.didPay': '¿Pagó?',
  'coach.home.table.nextPayment': 'Próx. Pago',
  'coach.home.table.subscriptionStatus': 'Estado de Suscripción',
  'coach.home.extraSectionInfo': 'Contenido adicional o breve resumen.',
  'coach.home.activeStudents': 'Alumnos Activos',
  'coach.home.totalStudents': 'Alumnos Totales',
  'coach.home.paidUp': 'Al Día en Pagos',
  'coach.home.averageDaysLeft': 'Prom. Días Restantes',
  'coach.home.studentsStatus': 'Estado de Alumnos',
  'coach.home.unpaidClients': 'Clientes Impagados',
  'coach.home.daysLeft': 'Días Restantes',
  'coach.home.last7daysFrequency': 'Frecuencia de Entrenamiento (Últimos 7 Días)',
  'coach.home.noDaysLeftData': 'Sin datos de días restantes aún',
  'coach.home.noFrequencyData7days': 'Sin datos de frecuencia para los últimos 7 días aún',
  'coach.home.noPaidData': 'Sin datos de pagos aún',
  'coach.home.noUnpaidData': 'Sin datos de impagos aún',
  'coach.home.allPaid': 'Todos los clientes han pagado sus suscripciones',

  'coach.sections.trainingPlans': 'Sesiones de Entrenamiento',
  'coach.sections.recentActivity': 'Actividad Reciente',
  'coach.sections.recentMessages': 'Mensajes Recientes',
  'coach.sections.workoutProgress': 'Progreso de Entrenamientos',
  'coach.sections.upcomingSessions': 'Próximas Sesiones',
  'coach.sections.trainingSessions': 'Sesiones de Entrenamiento',
  'coach.sections.trainingCycles': 'Ciclos de Entrenamiento',

  'coach.trainingCycle.description':
    'Aca puedes ver los ciclos de entrenamiento que tienes y crear nuevos. También puedes asignar sesiones de entrenamiento a un ciclo como tambien asignar un ciclo a un cliente.',

  'coach.buttons.newPlan': 'Nuevo Plan',
  'coach.buttons.editPlan': 'Editar Plan',
  'coach.buttons.openChat': 'Abrir Chat',
  'coach.buttons.upgradePlan': 'Mejorar Plan',
  'coach.buttons.import': 'Importar desde CSV/XLSX',
  'coach.buttons.assignPlans': 'Asignar Sesiones',
  'coach.buttons.unassignPlans': 'Desasignar Sesiones',
  'coach.subscription.status': 'Estado de Suscripción',
  'coach.subscription.clientsManaged': 'Clientes Gestionados: {current}/{max}',

  'coach.progress.completed': 'Completado: {count}',
  'coach.progress.pending': 'Pendiente: {count}',
  'coach.progress.expired': 'Expirado: {count}',
  'coach.progress.total': '{completed}/{total} Completados',

  'coach.calendar.noUpcomingSession': 'Sin sesiones próximas',

  'coach.chart.completed': 'Completados',
  'coach.chart.pending': 'Pendientes',
  'coach.chart.expired': 'Expirados',

  // ForgotPassword
  'forgotPassword.title': 'Olvidé mi Contraseña',
  'forgotPassword.email': 'Correo Electrónico',
  'forgotPassword.emailPlaceholder': 'Ingresa tu correo electrónico',
  'forgotPassword.message':
    'Ingresa tu correo electrónico para recibir un código de verificación y restablecer tu contraseña.',
  'forgotPassword.sendCode': 'Enviar Código',
  'forgotPassword.sendLink': 'Enviar Enlace de Restablecimiento',
  'forgotPassword.codeSent': 'Código de verificación enviado a tu correo',
  'forgotPassword.codeMessage': 'Por favor ingresa el código de verificación enviado a {email}',
  'forgotPassword.verificationSuccess': '¡Código verificado exitosamente! Ahora puedes restablecer tu contraseña.',
  'forgotPassword.success': 'El enlace para restablecer la contraseña ha sido enviado a tu correo.',
  'forgotPassword.error': 'Algo salió mal',
  'forgotPassword.error.emailRequired': 'El correo electrónico es obligatorio',
  'forgotPassword.confirm.exit':
    'Si salís ahora, vas a tener que solicitar un nuevo código de verificación. ¿Querés salir?',

  // HomePage
  'home.header.features': 'Características',
  'home.header.pricing': 'Precios',
  'home.header.about': 'Acerca de',
  'home.header.contact': 'Contacto',
  'home.header.login': 'Iniciar Sesión',
  'home.header.plans': 'Planes',

  'home.hero.title': 'Transforma Tu Viaje Fitness con TrainEase',
  'home.hero.subtitle': 'Empodera a los entrenadores, motiva a los clientes y alcanza metas de fitness juntos.',

  'home.hero.getStarted': 'Comenzar',
  'home.hero.learnMore': 'Aprender Más',
  'home.hero.transformYour': 'Transforma Tu',
  'home.hero.fitnessJourney': 'Viaje Fitness',
  'home.hero.withTrainEase': 'con TrainEase',
  'home.hero.easyToUse': 'Fácil de usar',
  'home.hero.safeAndReliable': 'Seguro y confiable',
  'home.hero.support': 'Soporte 24/7',

  'home.features.title': 'Características Clave',
  'home.features.manageClients': 'Gestionar Clientes',
  'home.features.manageClientsDesc': 'Gestiona fácilmente los detalles y el progreso de tus clientes en un solo lugar.',
  'home.features.customPlans': 'Sesiones de Entrenamiento Personalizados',
  'home.features.customPlansDesc':
    'Crea rutinas de entrenamiento personalizadas adaptadas a las necesidades de cada cliente.',
  'home.features.trackProgress': 'Seguimiento del Progreso',
  'home.features.trackProgressDesc': 'Visualiza el progreso del cliente con gráficos y reportes basados en datos.',
  'home.features.videoTutorials': 'Tutoriales en Video',
  'home.features.videoTutorialsDesc':
    'Accede a una biblioteca completa de videos de ejercicios y crea demostraciones de entrenamientos personalizados.',

  'home.pricing.title': 'Planes de Precios',
  'home.pricing.maxClients': 'Clientes Máximos: {max}',

  'home.footer.contact': 'Contacto',
  'home.footer.contactWhatsApp': 'Contactar por WhatsApp',

  'home.hero.platform': 'Plataforma Profesional de Fitness',
  'home.hero.trustIndicator1': 'Fácil de usar',
  'home.hero.trustIndicator2': 'Seguro y confiable',
  'home.hero.trustIndicator3': 'Soporte 24/7',
  'home.hero.feature1': 'Gestión de clientes',
  'home.hero.feature2': 'Seguimiento de progreso',
  'home.hero.feature3': 'Tutoriales en video',

  'home.features.subtitle': 'Descubre las herramientas que transformarán tu forma de entrenar y gestionar clientes',
  'home.pricing.subtitle': 'Elige el plan que mejor se adapte a tus necesidades y comienza a transformar tu negocio',
  'home.pricing.perMonth': 'por mes',
  'home.pricing.customPlans': 'Planes personalizados',
  'home.pricing.progressTracking': 'Seguimiento de progreso',
  'home.pricing.support': 'Soporte 24/7',
  'home.footer.description':
    'Transforma tu negocio de fitness con la plataforma más completa para entrenadores profesionales.',
  'home.footer.copyright': '© 2024 TrainEase. Todos los derechos reservados.',

  'home.hero.rating': '5.0 Rating',
  'home.hero.coaches': '1000+ Coaches',
  'home.hero.watchDemo': 'Ver Demo',
  'home.hero.customTrainingPlans': 'Planes de Entrenamiento Personalizados',
  'home.hero.customTrainingPlansDesc':
    'Crea rutinas de entrenamiento personalizadas adaptadas a las necesidades y objetivos de cada cliente.',
  'home.hero.trustedBy': 'Confiado por',

  'home.login.title': 'Iniciar sesión',
  'home.login.email': 'Correo electrónico',
  'home.login.emailPlaceholder': 'Ingresa tu correo electrónico',
  'home.login.password': 'Contraseña',
  'home.login.passwordPlaceholder': 'Ingresa tu contraseña',
  'home.login.forgotPassword': '¿Olvidaste tu contraseña?',
  'home.login.noAccount': '¿No tienes una cuenta?',
  'home.login.signUp': 'Regístrate',
  'home.login.validation.emailRequired': 'El correo electrónico es obligatorio',
  'home.login.validation.emailInvalid': 'Ingresa un correo electrónico válido',
  'home.login.validation.passwordRequired': 'La contraseña es obligatoria',
  'home.login.error.generic': 'No pudimos iniciar sesión. Intenta nuevamente.',

  'home.signup.title': 'Registrarse',
  'home.signup.email': 'Correo electrónico',
  'home.signup.emailPlaceholder': 'Ingresa tu correo electrónico',
  'home.signup.password': 'Contraseña',
  'home.signup.passwordPlaceholder': 'Crea una contraseña segura',
  'home.signup.confirmPassword': 'Confirmar contraseña',
  'home.signup.confirmPasswordPlaceholder': 'Confirma tu contraseña',
  'home.signup.haveAccount': '¿Ya tienes una cuenta?',
  'home.signup.login': 'Inicia sesión',
  'home.signup.validation.emailRequired': 'El correo electrónico es obligatorio',
  'home.signup.validation.emailInvalid': 'Ingresa un correo electrónico válido',
  'home.signup.validation.passwordRequired': 'La contraseña es obligatoria',
  'home.signup.validation.confirmPasswordRequired': 'Confirma tu contraseña',
  'home.signup.validation.passwordTooShort': 'La contraseña debe tener al menos 6 caracteres',
  'home.signup.validation.passwordMismatch': 'Las contraseñas no coinciden',
  'home.signup.success': '¡Cuenta creada! Revisa tu correo para verificarla.',
  'home.signup.error.generic': 'No pudimos completar el registro. Intenta nuevamente.',
  'home.pricing.subscribe': 'Suscribirse',

  'home.toast.verifyEmail': '¡Verifica tu correo antes de iniciar sesión!',
  'home.toast.checkEmail': '¡Revisa tu correo para continuar!',
  'home.toast.error': 'Error',
  'home.toast.success': 'Éxito',

  'home.error.verifyEmail': '¡Verifica tu correo electrónico antes de iniciar sesión!',
  'home.error.checkEmail': '¡Revisa tu correo para continuar!',
  'home.verification.title': 'Verificación de Correo',
  'home.verification.message': 'Por favor ingresa el código de verificación enviado a {email}',
  'home.verification.code': 'Código de verificación',
  'home.verification.verify': 'Verificar',
  'home.verification.success': '¡Correo verificado exitosamente!',
  'home.verification.error': 'Error al verificar el correo',
  'home.verification.error.invalidCode': 'Código de verificación inválido',
  'home.verification.resend': 'Reenviar código',
  'home.verification.resendSuccess': '¡Código de verificación reenviado exitosamente!',
  'home.verification.resendError': 'Error al reenviar el código de verificación',

  // ResetPassword
  'resetPassword.title': 'Restablecer Contraseña',
  'resetPassword.message': 'Ingresa tu nueva contraseña',
  'resetPassword.newPassword': 'Nueva Contraseña',
  'resetPassword.newPasswordPlaceholder': 'Ingresa tu nueva contraseña',
  'resetPassword.confirmPassword': 'Confirmar Contraseña',
  'resetPassword.confirmPasswordPlaceholder': 'Confirma tu nueva contraseña',
  'resetPassword.button': 'Restablecer Contraseña',
  'resetPassword.success': 'Contraseña restablecida exitosamente',
  'resetPassword.error.match': 'Las contraseñas no coinciden',
  'resetPassword.error.passwordRequired': 'La contraseña es obligatoria',
  'resetPassword.error.confirmPasswordRequired': 'Confirma tu contraseña',
  'resetPassword.error.passwordTooShort': 'La contraseña debe tener al menos 6 caracteres',
  'resetPassword.error.generic': 'Algo salió mal',
  'resetPassword.confirm.exit': 'Si salís ahora, tu contraseña no se cambiará. ¿Querés salir?',

  // NotSubscribed
  'notSubscribed.title': 'Sin suscripción activa',
  'notSubscribed.message': 'No tienes ninguna suscripción disponible. Habla con tu entrenador para solucionar esto.',
  'notSubscribed.button': 'Ir al Inicio de Sesión',

  // Unauthorized
  'unauthorized.title': 'No Autorizado',
  'unauthorized.message': 'No tienes permiso para ver esta página.',
  'unauthorized.button': 'Ir al Inicio de Sesión',

  // WorkoutTable
  'workoutTable.trainingDay': 'Día de Entrenamiento: {day}',
  'workoutTable.exercise': 'Ejercicio',
  'workoutTable.day': '{day} - {plan}',
  'workoutTable.selectCycleDay': 'Selecciona un ciclo y un día de la semana',
  'workoutTable.cycle': 'Ciclo',
  'workoutTable.dayOfWeek': 'Día de la semana:',
  'workoutTable.selectCycle': 'Seleccionar Ciclo',
  'workoutTable.selectDay': 'Seleccionar Día',
  'workoutTable.monday': 'Lunes',
  'workoutTable.tuesday': 'Martes',
  'workoutTable.wednesday': 'Miércoles',
  'workoutTable.thursday': 'Jueves',
  'workoutTable.friday': 'Viernes',
  'workoutTable.saturday': 'Sábado',
  'workoutTable.sunday': 'Domingo',
  'workoutTable.createNewWorkout': 'Crear Nuevo Entrenamiento',
  'workoutTable.addTraining': 'Agregar Entrenamiento',
  'workoutTable.addExercise': 'Agregar Ejercicio',
  'workoutTable.selectExercise': 'Seleccionar Ejercicio',
  'workoutTable.selectWeeks': 'Seleccionar Semanas',
  'workoutTable.week': 'Semana {week}',
  'workoutTable.modifyAll': 'Modificar Todas',
  'workoutTable.addNewExercise': 'Ejercicio',
  'workoutTable.sets': 'Series',
  'workoutTable.repetitions': 'Repeticiones',
  'workoutTable.weight': 'Peso',
  'workoutTable.time': 'Tiempo',
  'workoutTable.restInterval': 'Intervalo de Descanso',
  'workoutTable.tempo': 'Tempo',
  'workoutTable.notes': 'Notas',
  'workoutTable.difficulty': 'Dificultad',
  'workoutTable.duration': 'Duración',
  'workoutTable.distance': 'Distancia',
  'workoutTable.newExercise': 'Nuevo Ejercicio',
  'workoutTable.selectGroup': 'Seleccionar Grupo',
  'workoutTable.addNewGroup': 'Grupo',
  'workoutTable.enterTrainingName': 'Ingresa el nombre del entrenamiento',
  'workoutTable.enterName': 'Ingresa el nombre del entrenamiento',
  'workoutTable.trainingName': 'Nombre del Entrenamiento',
  'workoutTable.error.verifyChanges': 'Error al verificar los cambios',
  'workoutTable.error.deleteExercises': 'Error al eliminar los ejercicios',
  'workoutTable.deleteExercise': 'Eliminar Ejercicio',
  'workoutTable.exercisesDeleted': 'Ejercicios eliminados: ',
  'workoutTable.exercisesUpdated': 'Ejercicios actualizados: ',
  'workoutTable.selectProperties': 'Seleccionar Propiedades',
  'workoutTable.newTraining': 'Nuevo Entrenamiento',
  'workoutTable.editTraining': 'Editar Entrenamiento',
  'workoutTable.addProperties': 'Agregar Propiedades',
  'workoutTable.newCycle': 'Nuevo Ciclo',
  'workoutTable.restDuration': 'Duración de Descanso',
  'workoutTable.exerciseAlreadyExists': 'El ejercicio ya existe en el grupo',
  'exercise.properties.loading': 'Cargando propiedades...',

  // Header
  'header.home': 'Inicio',
  'header.profile': 'Perfil',
  'header.clients': 'Clientes',
  'header.logout': 'Cerrar Sesión',
  'header.chat': 'Chat',
  'header.notifications': 'Notificaciones',
  'header.noNotifications': 'No hay nuevas notificaciones',
  'header.settings': 'Configuración',
  'header.plans': 'Planes',
  'settings.language.es': 'Español',
  'settings.language.en': 'Inglés',
  'settings.unitConfiguration': 'Configuración de Unidades',
  'exercise.video.view': 'Ver Video',
  // CoachProfileForm
  'coachProfileForm.title': 'Completa tu perfil de entrenador',
  'coachProfileForm.name': 'Nombre',
  'coachProfileForm.trainingType': 'Especialidades',
  'coachProfileForm.selectTrainingTypes': 'Selecciona tus especialidades',
  'coachProfileForm.hasGym': 'Tengo acceso a un gimnasio/estudio',
  'coachProfileForm.gymLocation': 'Ubicación del gimnasio',
  'coachProfileForm.bio': 'Biografía',
  'coachProfileForm.experience': 'Experiencia',
  'coachProfileForm.subscriptionType': 'Tipo de suscripción',
  'coachProfileForm.freeTrial': 'Prueba gratuita · hasta 3 clientes',
  'coachProfileForm.paid': 'Plan profesional',
  'coachProfileForm.choosePlan': 'Elegir plan',
  'coachProfileForm.subscriptionPlan': 'Plan seleccionado',
  'coachProfileForm.plan': 'Plan',
  'coachProfileForm.price': 'Precio',
  'coachProfileForm.clients': 'clientes',
  'coachProfileForm.submit': 'Publicar perfil',
  'coachProfileForm.summary': 'Resumen del perfil',
  'coachProfileForm.success': 'Perfil actualizado',
  'coachProfileForm.success.message': 'Gracias por suscribirte, {name}. Te llevamos al panel principal.',
  'coachProfileForm.error': 'Algo salió mal',
  'coachProfileForm.error.noUser': 'Vuelve a iniciar sesión para completar tu perfil.',
  'coachProfileForm.error.missingToken': 'Falta el token de autenticación.',
  'coachProfileForm.error.selectPlan': 'Por favor, selecciona un plan de suscripción.',
  'coachProfileForm.dialog.header': 'Selecciona un plan de suscripción',
  'coachProfileForm.step.personalInfo': 'Información personal',
  'coachProfileForm.step.trainingDetails': 'Detalles de entrenamiento',
  'coachProfileForm.step.subscription': 'Suscripción',
  'coachProfileForm.step.confirmation': 'Revisión final',
  'coachProfileForm.confirmationMessage': 'Revisa toda la información antes de confirmar.',
  'coachProfileForm.subtitle.personalInfo':
    'Cuéntanos brevemente sobre tu experiencia para que los clientes te conozcan.',
  'coachProfileForm.subtitle.trainingDetails': 'Selecciona los estilos que entrenas y dinos dónde trabajas.',
  'coachProfileForm.subtitle.subscription': 'Elige cómo quieres comenzar a usar TrainEase.',
  'coachProfileForm.subtitle.confirmation': 'Verifica cada detalle antes de publicar tu perfil.',
  'coachProfileForm.helper.training': 'Destaca 2 o 3 especialidades',
  'coachProfileForm.helper.freeTrial': 'Comienza gratis e incorpora hasta tres clientes.',
  'coachProfileForm.helper.paid': 'Desbloquea pagos, automatización y analíticas avanzadas.',
  'coachProfileForm.placeholder.pending': 'Pendiente',
  'coachProfileForm.placeholder.name': 'Ej.: Alex López',
  'coachProfileForm.placeholder.bio': 'Comparte tu filosofía, certificaciones o logros.',
  'coachProfileForm.placeholder.experience': 'Años de experiencia, equipos o hitos relevantes.',
  'coachProfileForm.placeholder.gymLocation': 'Ciudad, barrio o nombre del estudio',
  'coachProfileForm.plan.notSelected': 'Aún no seleccionaste un plan',
  'coachProfileForm.plan.cta': 'Seleccionar plan',
  'coachProfileForm.validation.name': 'El nombre es obligatorio.',
  'coachProfileForm.validation.bio': 'La biografía es obligatoria.',
  'coachProfileForm.validation.experience': 'La experiencia es obligatoria.',
  'coachProfileForm.validation.trainingType': 'Selecciona al menos una especialidad.',
  'coachProfileForm.validation.gymLocation': 'Ingresa la ubicación del gimnasio.',
  'coachProfileForm.validation.subscriptionType': 'El tipo de suscripción es obligatorio.',
  'coachProfileForm.validation.plan': 'Selecciona un plan para continuar.',

  // StudentDialog
  'gender.male': 'Masculino',
  'gender.female': 'Femenino',
  'gender.other': 'Otro',
  'fitnessGoal.weightLoss': 'Pérdida de peso',
  'fitnessGoal.muscleGain': 'Ganancia muscular',
  'fitnessGoal.gainMobility': 'Ganar movilidad',
  'fitnessGoal.maintenance': 'Mantenimiento',
  'fitnessGoal.flexibility': 'Flexibilidad',
  'fitnessGoal.other': 'Otro',
  'activityLevel.sedentary': 'Sedentario',
  'activityLevel.moderatelyActive': 'Moderadamente activo',
  'activityLevel.veryActive': 'Muy activo',
  'student.success': 'Éxito',
  'student.updatedSuccessfully': 'Estudiante actualizado exitosamente',
  'student.addedSuccessfully': 'Estudiante agregado exitosamente',
  'student.error.nameEmailRequired': 'El nombre y el correo electrónico no pueden estar vacíos',
  'student.error.birthdateInvalid': 'La fecha de nacimiento no puede ser posterior a hoy',
  'student.validation.error': 'Por favor, corrige los errores en el formulario antes de continuar',
  'student.warning.youngClient': 'El cliente es muy joven, por favor verifica la fecha de nacimiento',
  'validation.error': 'Por favor, corrige los errores en el formulario antes de continuar',
  'student.confirmation.create': '¿Estás seguro de que deseas crear este estudiante?',
  'student.confirmation.edit': '¿Estás seguro de que deseas guardar los cambios?',
  'student.error.noSubscription': 'El cliente no tiene una suscripción activa',
  'student.error.noCoachPlans':
    'No hay planes de entrenador disponibles. Por favor, crea un plan de entrenador primero',
  'student.confirm.createPlanFirst.header': 'Crear un plan primero',
  'student.confirm.createPlanFirst.message':
    'Todavía no tenés planes creados. ¿Querés crear uno ahora para asignar esta suscripción?',
  'student.verificationEmailSent': '¡Correo de verificación enviado exitosamente!',
  confirmation: 'Confirmación',
  email: 'Correo Electrónico',
  name: 'Nombre',
  fitnessGoal: 'Objetivo Fitness',
  activityLevel: 'Nivel de Actividad',
  gender: 'Género',
  height: 'Altura',
  weight: 'Peso',
  birthdate: 'Fecha de Nacimiento',
  save: 'Guardar',
  error: 'Error',
  warning: 'Advertencia',

  // AssignSubscriptionDialog
  'assignSubscription.error.selectPlan': 'Por favor, selecciona un plan de entrenador',
  'assignSubscription.error.startDateRequired': 'Por favor, selecciona una fecha de inicio',

  'assignSubscription.success': 'Suscripción asignada exitosamente',
  'assignSubscription.autoCalculated': 'auto-calculada',
  'assignSubscription.noPlansYet':
    'Aún no tienes servicios creados. Crea tu primer servicio para asignar esta suscripción.',
  'assignSubscription.createFirstPlan': 'Crear mi primer servicio',
  'assignSubscription.createInlinePlan': 'Crear nuevo servicio',
  'coach.plan.error.nameRequired': 'El nombre del plan es obligatorio',
  'coach.plan.error.priceRequired': 'El precio del plan es obligatorio',
  'assignSubscription.button': 'Asignar Suscripción',
  startDate: 'Fecha de Inicio',
  endDate: 'Fecha de Fin',
  plan: 'Plan',
  success: 'Éxito',

  // Mensajes de error de UtilFunctions
  'error.selectStartDate': 'Por favor, selecciona una fecha de inicio',
  'error.selectEndDate': 'Por favor, selecciona una fecha de fin',
  'error.startDateAfterEndDate': 'La fecha de inicio no puede ser posterior a la fecha de fin',
  'error.nameRequired': 'El nombre es requerido',
  'error.emailRequired': 'El correo electrónico es requerido',
  'error.fitnessGoalRequired': 'El objetivo fitness es requerido',
  'error.activityLevelRequired': 'El nivel de actividad es requerido',
  'error.birthdateRequired': 'La fecha de nacimiento es requerida',
  'error.birthdateInFuture': 'La fecha de nacimiento no puede estar en el futuro',
  'error.ageRequirement': 'La edad debe ser al menos de 10 años',
  'error.genderRequired': 'El género es requerido',
  'error.heightRange': 'La altura debe estar entre 100 cm y 250 cm',
  'error.weightRange': 'El peso debe estar entre 30 kg y 300 kg',

  // NewCoachProfile
  'coach.plan.success.created': 'Plan creado exitosamente',
  'coach.plan.success.created.message': 'El plan {name} ha sido creado exitosamente',
  'coach.plan.success.updated': 'Plan actualizado exitosamente',
  'coach.plan.success.updated.message': 'El plan {name} ha sido actualizado exitosamente',
  'coach.plan.success.deleted': 'Plan eliminado exitosamente',
  'coach.plan.success.deleted.message': 'El plan {name} ha sido eliminado exitosamente',
  'coach.plan.error.requiredFields': 'Completá los campos obligatorios',
  'coach.plan.error.save': 'No se pudo guardar el plan',
  'coach.plan.error.delete': 'No se pudo eliminar el plan',
  'coach.plan.error.name.empty': 'El nombre del plan no puede estar vacío',
  'coach.plan.error.price.zero': 'El precio del plan no puede ser 0',
  'coach.plan.error.workouts.zero': 'El número de entrenamientos por semana no puede ser 0',
  'coach.plan.error.not.updated': 'Error al actualizar el plan',
  'coach.plan.create': 'Crear Nuevo Plan de Entrenador',
  'coach.plan.edit': 'Editar Plan de Entrenador',
  'coach.plan.name': 'Nombre del Plan',
  'coach.plan.price': 'Precio',
  'coach.plan.paymentFrequency': 'Frecuencia de Pago',
  'coach.plan.paymentFrequency.placeholder': 'Seleccionar frecuencia de pago',
  'coach.plan.paymentFrequency.monthly': 'Mensual',
  'coach.plan.paymentFrequency.weekly': 'Semanal',
  'coach.plan.paymentFrequency.perSession': 'Por Sesión',
  'coach.plan.description':
    'Aquí puedes crear y gestionar tanto planes de entrenamiento generales como planes personalizados asignados a tus clientes/alumnos.',
  'coach.assign.success': 'Entrenamiento asignado exitosamente',
  'coach.assign.error': 'Error al asignar el entrenamiento',
  'coach.assign.selectClient': 'Selecciona un cliente',
  'coach.assign.selectWorkouts': 'Selecciona un entrenamiento',
  'coach.assign.confirm': 'Confirmar',
  'coach.assign.dialog.header': 'Asignar Entrenamientos a Cliente',
  'coach.assign.cycle.dialog.header': 'Asignar Ciclo a Cliente',
  'coach.assign.dialog.selectedWorkouts': 'Planes seleccionados:',
  'coach.assign.dialog.selectClient': 'Selecciona un cliente',
  'coach.assign.dialog.selectedCycle': 'Ciclo seleccionado:',
  'coach.assign.dialog.selectedCycle.name': 'Nombre del Ciclo',
  'coach.assign.dialog.selectedCycle.duration': 'Duración',
  'coach.assign.dialog.selectedCycle.weeks': 'Semanas',
  'coach.assign.dialog.selectedCycle.days': 'Días',
  'coach.assign.dialog.selectedCycle.workouts': 'Entrenamientos',
  'coach.assign.selectRpeMethod': 'Método de Medición RPE',
  'coach.assign.selectRpeMethodPlaceholder': 'Seleccionar método RPE',
  'coach.assign.error.rpeRequired': 'Debes seleccionar un método RPE',
  'coach.assign.error.detail': 'Por favor selecciona un cliente y al menos un entrenamiento',

  // RPE Method

  'coach.rpe.edit': 'Editar Método RPE',

  'coach.rpe.value': 'Valor',
  'coach.rpe.color': 'Color (ej., #FF0000)',
  'coach.rpe.emoji': 'Emoji (ej., 🔥)',

  // AssignWorkoutToCycleDialog
  'assignWorkoutToCycleDialog.unassignByDay': 'Desasignar por día',
  'assignWorkoutToCycleDialog.deleteEntireCycle': 'Eliminar ciclo completo',
  'assignWorkoutToCycleDialog.selectCycle': 'Seleccionar Ciclo',
  'assignWorkoutToCycleDialog.selectDay': 'Seleccionar Día',
  'assignWorkoutToCycleDialog.selectWorkout': 'Seleccionar Entrenamiento',
  'assignWorkoutToCycleDialog.assignWorkoutsToCycle': 'Asignar Entrenamientos al Ciclo',
  'assignWorkoutToCycleDialog.unassignWorkoutsFromCycle': 'Desasignar Entrenamientos del Ciclo',
  'assignWorkoutToCycleDialog.cycle': 'Ciclo',
  'assignWorkoutToCycleDialog.day': 'Día',
  'assignWorkoutToCycleDialog.workout': 'Entrenamiento',
  'assignWorkoutToCycleDialog.assign': 'Asignar',
  'assignWorkoutToCycleDialog.unassign': 'Desasignar',
  'assignWorkoutToCycleDialog.error.assign': 'Error al Asignar',
  'assignWorkoutToCycleDialog.error.assign.detail': 'Ocurrió un error al asignar los entrenamientos al ciclo.',
  'assignWorkoutToCycleDialog.success.assign': 'Entrenamientos Asignados',
  'assignWorkoutToCycleDialog.success.assign.detail': 'Los entrenamientos han sido asignados exitosamente al ciclo.',
  'assignWorkoutToCycleDialog.error.unassign': 'Error al Desasignar',
  'assignWorkoutToCycleDialog.error.unassign.detail': 'Ocurrió un error al desasignar los entrenamientos del ciclo.',
  'assignWorkoutToCycleDialog.success.unassign': 'Entrenamientos Desasignados',
  'assignWorkoutToCycleDialog.success.unassign.detail':
    'Los entrenamientos han sido desasignados exitosamente del ciclo.',
  'assignWorkoutToCycleDialog.deleteCycle': 'Eliminar Ciclo',
  'assignWorkoutToCycleDialog.warningTitle': 'Advertencia',
  'assignWorkoutToCycleDialog.cancel': 'Cancelar',
  'assignWorkoutToCycleDialog.confirm': 'Confirmar',
  'assignWorkoutToCycleDialog.verificationTitle': 'Verificación de Eliminación',
  'assignWorkoutToCycleDialog.warningMessage':
    'Este ciclo de entrenamiento tiene {count} registros de retroalimentación que se perderán al eliminarlo.',
  'assignWorkoutToCycleDialog.forceDelete': 'Forzar eliminación y perder todos los registros',
  'assignWorkoutToCycleDialog.safeToDelete': 'Este ciclo puede ser eliminado de forma segura.',
  'assignWorkoutToCycleDialog.assignment': 'Asignación',
  'assignWorkoutToCycleDialog.selectDayOfWeek': 'Seleccionar Día de la Semana',
  'assignWorkoutToCycleDialog.addAssignment': 'Agregar Asignación',
  'assignWorkoutToCycleDialog.assignWorkouts': 'Asignar Entrenamientos',
  'assignWorkoutToCycleDialog.unassignWorkouts': 'Desasignar Entrenamientos',
  'assignWorkoutToCycleDialog.success.deleteCycle': 'Ciclo Eliminado',
  'assignWorkoutToCycleDialog.success.deleteCycle.detail': 'El ciclo ha sido eliminado exitosamente.',
  'assignWorkoutToCycleDialog.error.deleteCycle': 'Error al Eliminar',
  'assignWorkoutToCycleDialog.error.deleteCycle.detail': 'Ocurrió un error al eliminar el ciclo.',
  'assignWorkoutToCycleDialog.error.selectWorkoutAndDay':
    'Por favor seleccione un entrenamiento y un día de la semana para la última asignación.',
  'assignWorkoutToCycleDialog.error.selectAtLeastOneWorkout': 'Por favor seleccione al menos un entrenamiento.',
  'assignWorkoutToCycleDialog.dayOfWeek': 'Día de la Semana',
  'assignWorkoutToCycleDialog.selectWorkoutToUnassign': 'Seleccionar Entrenamiento a Desasignar',
  'assignWorkoutToCycleDialog.dependenciesTitle': 'Entrenamientos Dependientes',

  // CreateTrainingCycleDialog
  'createCycle.dialog.header': 'Crear Ciclo de Entrenamiento',
  'createCycle.cycleName': 'Nombre del Ciclo',
  'createCycle.clientFacingName': 'Nombre visible para el cliente',
  'createCycle.clientFacingName.placeholder': 'Dejar vacío para usar el nombre del ciclo',
  'createCycle.clientFacingName.help':
    'Si lo completas, el cliente verá este nombre en lugar del nombre interno del ciclo.',
  'common.optional': 'opcional',
  'createCycle.durationInMonths': 'Duración en Meses',
  'createCycle.durationInWeeks': 'Duración en Semanas',
  'createCycle.button.create': 'Crear Ciclo Vacío',
  'createCycle.button.create.confirm':
    '¿Estás seguro de que deseas crear este ciclo sin ningún entrenamiento asignado? Puedes agregar entrenamientos asignados más tarde.',
  'createCycle.fromTemplate': 'Desde Plantilla',
  'createCycle.useGlobalRpe': 'Usar la misma Medición de Carga Subjetiva para todas las sesiones',
  'createCycle.globalRpeMethod': 'Medición de Carga Subjetiva para todas las sesiones',
  'createCycle.selectRpeMethod': 'Medición de Carga Subjetiva',
  'createCycle.selectRpeMethodPlaceholder': 'Seleccionar Medición de Carga Subjetiva',
  'createCycle.error.selectRpeMethod': 'Por favor seleccioná una Medición de Carga Subjetiva',
  'error.fetchingStudents': 'Error al obtener estudiantes',
  'success.cycleCreated': '¡Ciclo de entrenamiento creado exitosamente!',
  'error.allFieldsRequired': 'Todos los campos son obligatorios',
  'error.enterDuration': 'Por favor, ingresa una duración en semanas o meses',
  selectClient: 'Selecciona un cliente',
  client: 'Cliente',

  'settings.title': 'Configuraciones',
  'settings.darkMode': 'Modo Oscuro',
  'settings.viewPreference': 'Preferencia de Vista',
  'settings.view.default': 'Vista Predeterminada',
  'settings.view.excel': 'Vista Excel',
  'settings.language': 'Idioma',
  'settings.allowIncompleteStudent': 'Permitir agregar estudiantes sin datos completos',
  'settings.developerOptions': 'Opciones para Desarrolladores',
  'settings.save': 'Guardar Configuraciones',
  'plansPage.title': 'Página de Planes',
  'plansPage.createTemplate': 'Crear Plantilla',
  'plansPage.filter.all': 'Todos',
  'plansPage.filter.general': 'General',
  'plansPage.filter.placeholder': 'Seleccionar Filtro',
  'plansPage.tab.general': 'Planes Generales',
  'plansPage.tab.assigned': 'Planes Asignados',
  'plansPage.assign': 'Asignar',
  'plansPage.edit': 'Editar',
  'plansPage.delete': 'Eliminar',
  'plansPage.createCycleDialog.header': 'Crear Ciclo de Entrenamiento',
  'plansPage.templateNamePlaceholder': 'Nombre de la Plantilla',
  'plansPage.durationInWeeks': 'Duración en Semanas',
  'plansPage.durationInMonths': 'Duración en Meses',
  'plansPage.durationPlaceholder': 'Duración en {unit}',
  'plansPage.weeks': 'semanas',
  'plansPage.months': 'meses',
  'plansPage.trainingWeeks': 'Semanas de Entrenamiento',
  'plansPage.week': 'Semana {weekNumber}',
  'plansPage.selectWorkout': 'Seleccionar Entrenamiento',
  'plansPage.selectDay': 'Seleccionar Día',
  'plansPage.monday': 'Lunes',
  'plansPage.tuesday': 'Martes',
  'plansPage.wednesday': 'Miércoles',
  'plansPage.thursday': 'Jueves',
  'plansPage.friday': 'Viernes',
  'plansPage.saturday': 'Sábado',
  'plansPage.sunday': 'Domingo',
  'plansPage.applyToAllWeeks': 'Aplicar a todas las semanas',
  'plansPage.addWorkout': 'Agregar Entrenamiento',
  'plansPage.workout': 'Entrenamiento',
  'plansPage.day': 'Día',
  'plansPage.addWeek': 'Agregar Semana',
  'plansPage.saveTemplate': 'Guardar Plantilla',
  'plansPage.error.selectWorkoutAndDay': 'Debes seleccionar un entrenamiento y un día',
  'plansPage.error.allFieldsRequired': 'Todos los campos son obligatorios',
  'plansPage.success.templateCreated': '¡Plantilla creada exitosamente!',
  'plansPage.error.creatingTemplate': 'Error al crear la plantilla',
  'plansPage.error.exceedDuration': 'No puedes agregar más semanas que la duración especificada.',
  'plansPage.confirmation.reduceWeeks': 'Reducir la duración eliminará las semanas adicionales. ¿Deseas continuar?',
  'plansPage.coachId': 'ID del Entrenador',
  'plansPage.numberOfWeeks': 'Número de Semanas',
  'plansPage.createCycle': 'Crear Ciclo',
  'plansPage.search.placeholder': 'Buscar planes por nombre...',
  'plansPage.cycles.search.placeholder': 'Buscar ciclos por nombre...',
  'plansPage.stats.total': 'Total',
  'plansPage.stats.assigned': 'Asignados',
  'plansPage.stats.unassigned': 'Sin asignar',
  'plansPage.stats.cyclesTotal': 'Total ciclos',
  'plansPage.stats.cyclesWeeks': 'Semanas',
  'plansPage.stats.cyclesSessions': 'Sesiones',
  'plansPage.selection.count': '{count, plural, one {# seleccionado} other {# seleccionados}}',
  'plansPage.selection.clear': 'Limpiar selección',
  'plansPage.empty.title': 'No tenés planes creados',
  'plansPage.empty.description': 'Creá tu primer plan de entrenamiento para poder asignarlo a tus alumnos.',
  'plansPage.empty.cycles.title': 'No tenés ciclos creados',
  'plansPage.empty.cycles.description': 'Creá tu primer ciclo de entrenamiento para organizar semanas y sesiones.',
  'plansPage.empty.search.title': 'Sin resultados',
  'plansPage.empty.search.description': 'No se encontraron coincidencias con ese nombre. Probá otro término.',
  'plansPage.card.groups': '{count, plural, one {# grupo} other {# grupos}}',
  'plansPage.showExercises': 'Mostrar ejercicios de las sesiones',
  'plansPage.card.exercises': '{count, plural, one {# ejercicio} other {# ejercicios}}',
  'plansPage.card.assignedCount': '{count, plural, one {# alumno} other {# alumnos}}',
  'plansPage.card.clientsSummary': '{first} +{rest} más',
  'plansPage.card.cycleWeeks': '{count, plural, one {# semana} other {# semanas}}',
  'plansPage.card.cycleMonths': '{count, plural, one {# mes} other {# meses}}',
  'plansPage.card.cycleWeekCount': '{count, plural, one {# semana} other {# semanas}}',
  'plansPage.card.cycleTotalSessions': '{count, plural, one {# sesión} other {# sesiones}}',
  'plansPage.card.cycleAvgPerWeek': '{avg}/sem promedio',
  'plansPage.card.cycleWeek1Preview': 'Semana 1',
  'plansPage.editCycleDialog.header': 'Editar Ciclo de Entrenamiento',
  'plansPage.viewCycleDialog.header': 'Ver Ciclo de Entrenamiento',
  'plansPage.success.cycleUpdated': '¡Ciclo actualizado exitosamente!',
  'plansPage.error.deletingCycle': 'Error al eliminar el ciclo',
  'plansPage.enableEdit': 'Habilitar Edición',
  'plansPage.disableEdit': 'Deshabilitar Edición',
  'editCycle.dialog.header': 'Editar Ciclo de Entrenamiento',
  'editCycle.namePlaceholder': 'Nombre del Ciclo',
  'editCycle.durationPlaceholder': 'Duración',
  'success.cycleUpdated': '¡Ciclo actualizado exitosamente!',
  'success.cycleDeleted': '¡Ciclo eliminado exitosamente!',
  'confirm.deleteCycle': '¿Estás seguro de que deseas eliminar este ciclo?',

  'coach.exercise.success.created': 'Ejercicio creado exitosamente',
  'coach.exercise.success.updated': 'Ejercicio actualizado exitosamente',
  'coach.exercise.success.deleted': 'Ejercicio eliminado exitosamente',
  'exercise.selectExercise': 'Seleccionar Ejercicio',
  'workoutTable.addGroup': 'Agregar Grupo',
  'common.selectDay': 'Seleccionar día',
  'workoutTable.changesDetected': '{count} cambios detectados',
  'workoutTable.changesSaved': 'Cambios guardados exitosamente',
  'workoutTable.missingExerciseIds': 'Los siguientes ejercicios no tienen ID asignado',
  'workoutTable.cannotMoveLastExercise': 'No se puede mover el último ejercicio de un grupo',
  'workoutTable.groupCannotBeEmpty': 'Un grupo no puede quedar sin ejercicios',
  'workoutTable.noGroupsAvailable': 'No hay grupos disponibles',
  'workoutTable.insertExercise': 'Insertar ejercicio aquí',
  'workoutTable.exerciseInserted': 'Ejercicio insertado correctamente',
  'workoutTable.groupInserted': 'Grupo insertado correctamente',

  'students.remainingDays': 'Días restantes',
  'students.fitnessGoal': 'Objetivo Fitness',
  'students.status': 'Estado',
  'students.status.verified': 'Verificado',
  'students.status.unverified': 'No Verificado',
  'students.status.unverified.tooltip': 'El correo electrónico no ha sido verificado',
  'students.resendVerification': 'Reenviar Verificación',
  'students.cancelSubscription': 'Cancelar Suscripción',
  'students.viewProfile': 'Ver Perfil',
  'students.registerPayment': 'Registrar Pago',
  'students.assignSubscription': 'Asignar Suscripción',

  'workoutTable.removeWorkout': 'Eliminar Entrenamiento',
  'coach.rpe.basicInfo': 'Información Básica',
  'coach.rpe.name.tooltip': 'Nombre del método RPE',
  'coach.rpe.step.tooltip': 'Incremento entre valores',
  'coach.rpe.minValue.tooltip': 'Valor mínimo del rango',
  'coach.rpe.maxValue.tooltip': 'Valor máximo del rango',
  'coach.rpe.value.tooltip': 'Valor numérico',
  'coach.rpe.color.tooltip': 'Color en formato hexadecimal (ej: #FF0000)',
  'coach.rpe.emoji.tooltip': 'Emoji representativo',
  'coach.rpe.generateValues': 'Generar Valores',
  'coach.rpe.generateValues.tooltip': 'Genera automáticamente valores basados en el rango y paso definidos',
  'coach.rpe.error.invalidRange': 'El rango y paso especificados no son válidos',
  'common.client': 'Cliente',
  'common.assignedOn': 'Asignado el',

  // Translations for dashboard calendar
  'dashboard.calendar.pendingStatus': 'Pendiente',
  'dashboard.calendar.completedStatus': 'Completado',
  'dashboard.calendar.expiredStatus': 'Expirado',
  'dashboard.calendar.currentStatus': 'En progreso',
  'dashboard.calendar.warningStatus': 'Atención requerida',

  'dashboard.calendar.addSession': 'Añadir sesión',
  'dashboard.calendar.addSessionTooltip': 'Añadir nuevo entrenamiento a este día',
  'dashboard.calendar.moreEvents': '{num} entrenamientos más',

  // Coach Exercise Management
  'coach.addExercise': 'Agregar Ejercicio',
  'coach.importExercises': 'Importar Ejercicios',
  'coach.dragAndDropExercises': 'Arrastra y suelta el archivo Excel aquí',
  'coach.exercises': 'Ejercicios',
  'coach.exerciseList': 'Lista de Ejercicios',
  'coach.noExercisesFound': 'No se encontraron ejercicios',
  'coach.missingExercises': 'Ejercicios con Datos Faltantes',
  'coach.missingExercisesWarning': 'Los siguientes ejercicios tienen datos importantes faltantes',
  'coach.noMissingExercises': 'No hay ejercicios con datos faltantes',
  'coach.exercises.title': 'Biblioteca de Ejercicios',
  'coach.exercise.title': 'Ejercicio',

  // Coach Plan Management
  'coach.createPlan': 'Crear Plan',
  'coach.plans.title': 'Planes de Entrenamiento',
  'coach.plan.title': 'Plan',
  'coach.noPlans': 'Aún no tienes planes de entrenamiento',
  'coach.createFirstPlan': 'Crea tu primer plan',
  'coach.createNewPlan': 'Crear Nuevo Plan',
  'coach.editPlan': 'Editar Plan',
  'coach.includeMealPlan': 'Incluye Plan de Alimentación',

  // Coach Client Management
  'coach.myClients': 'Mis Clientes',
  'coach.noClientsFound': 'No se encontraron clientes',
  'client.name': 'Nombre',
  'client.email': 'Correo',
  'client.status': 'Estado',
  'client.expiresOn': 'Vence el',
  'client.sendMessage': 'Enviar Mensaje',
  'client.title': 'Cliente',
  'common.view': 'Ver',
  'common.created': 'Creado',
  'common.complete': 'Completar',
  'common.createdAt': 'Creado el',
  'common.or': 'o',

  // Coach RPE Methods
  'coach.createRpeMethod': 'Crear Método de Medición',
  'coach.assignRpe': 'Asignar Medición Subjetiva',
  'coach.rpeMethods': 'Métodos de Medición Subjetiva',
  'coach.rpeAssignments': 'Asignaciones de Medición Subjetiva',
  'coach.noRpeMethods': 'Aún no tienes métodos de Medición Subjetiva',
  'coach.createFirstRpeMethod': 'Crea tu primer método de Medición Subjetiva',
  'coach.noRpeAssignments': 'No se encontraron asignaciones de Medición Subjetiva',
  'coach.createNewRpeMethod': 'Crear Nuevo Método de Medición Subjetiva',
  'coach.editRpeMethod': 'Editar Método de Medición Subjetiva',
  'rpe.method': 'Método de Medición Subjetiva',
  'rpe.targetType': 'Tipo de Objetivo',
  'rpe.targetName': 'Nombre del Objetivo',
  'rpe.step': 'Paso',
  'rpe.name': 'Nombre',
  'rpe.minValue': 'Valor Mínimo',
  'rpe.maxValue': 'Valor Máximo',
  'rpe.valuesMeta': 'Descripciones de Valores',
  'rpe.addValueMeta': 'Agregar Descripción de Valor',
  'rpe.noValuesMeta': 'Aún no hay descripciones de valores agregadas',
  'rpe.value': 'Valor',
  'rpe.description': 'Descripción',
  'rpe.setAsDefault': 'Usar este método por defecto',
  'rpe.isDefault': 'Método por defecto',
  'rpe.selectMethod': 'Seleccionar Método de Medición Subjetiva',
  'rpe.selectTargetType': 'Seleccionar Tipo de Objetivo',
  'rpe.selectTarget': 'Seleccionar Objetivo',
  'rpe.target': 'Objetivo',
  'coach.rpe.error.missingFields': 'Por favor selecciona todos los campos requeridos',
  'coach.rpe.clearValues': 'Limpiar Valores',
  'coach.rpe.clearValues.tooltip': 'Elimina todos los valores meta configurados',
  'coach.assignRpeMethod': 'Asignar Método de Medición Subjetiva',
  'coach.assignRpeMethod.tooltip': 'Asigna un método de Medición Subjetiva a un entrenamiento o ejercicio',

  // Coach Subscription
  'coach.subscription.plans': 'Planes de Suscripción',
  'coach.subscription.details': 'Detalles de Suscripción',
  'coach.subscription.includedFeatures': 'Todas las funciones incluidas',
  'coach.subscription.upgrade': 'Mejorar Plan',
  'coach.subscription.startDate': 'Fecha de Inicio',
  'coach.subscription.renewalDate': 'Fecha de Renovación',
  'coach.subscription.paymentMethod': 'Método de Pago',

  // Exercise
  'exercise.name': 'Nombre',
  'exercise.type': 'Tipo',
  'exercise.description': 'Descripción',
  'exercise.equipment': 'Equipamiento',
  'exercise.video': 'Video',
  'exercise.searchByName': 'Buscar por nombre',
  'exercise.searchByType': 'Buscar por tipo',
  'exercise.searchByDescription': 'Buscar por descripción',
  'exercise.selectType': 'Seleccionar Tipo',
  'exercise.watchVideo': 'Ver Video',
  'exercise.noVideo': 'No hay video disponible',
  'exercise.watchYouTube': 'Ver en YouTube',
  'exercise.missingData': 'Datos Faltantes',
  'exercise.title': 'Ejercicio',
  'exercise.create': 'Crear Ejercicio',
  'exercise.edit': 'Editar Ejercicio',
  'exercise.chooseVideo': 'Elegir Video',
  'exercise.uploadVideo': 'Subir Video',
  'exercise.previewVideo': 'Vista Previa del Video',
  'exercise.preview': 'Vista Previa',
  'exercise.videoNotSupported': 'Tu navegador no soporta la etiqueta de video',
  'exercise.youtubeUrl': 'URL de YouTube',
  'exercise.multimedia': 'Multimedia',
  'exercise.count': 'Cantidad',
  'exercise.equipmentNeeded': 'Equipamiento Necesario',
  'exercise.bodyAreas': 'Áreas del cuerpo',

  'exercises.globalBadge': 'Biblioteca',
  'exercises.globalBadge.tooltip': 'Ejercicio de la biblioteca pública (no editable)',
  'exercises.globalBadge.actionsLocked': 'Solo lectura',
  'rpe.globalBadge': 'Global',
  'rpe.globalBadge.tooltip': 'Método global pre-cargado (no editable)',
  'rpe.globalBadge.actionsLocked': 'Solo lectura',
  'coach.onboarding.title': '👋 Te ayudamos a empezar',
  'coach.onboarding.progress': 'Llevás {done} de {total} pasos completados',
  'coach.onboarding.dismiss': 'No mostrar más',
  'coach.onboarding.task.profile': 'Completá tu perfil',
  'coach.onboarding.task.profile.cta': 'Completar perfil',
  'coach.onboarding.task.library': 'Explorá la biblioteca de ejercicios',
  'coach.onboarding.task.library.cta': 'Ver biblioteca',
  'coach.onboarding.task.template': 'Creá tu primera plantilla de sesión',
  'coach.onboarding.task.template.cta': 'Crear plantilla',
  'coach.onboarding.task.cycle': 'Creá tu primer ciclo de entrenamiento',
  'coach.onboarding.task.cycle.cta': 'Crear ciclo',
  'coach.onboarding.task.client': 'Invitá tu primer alumno',
  'coach.onboarding.task.client.cta': 'Invitar alumno',
  'coach.onboarding.task.assignPlan': 'Asignale un plan a tu alumno',
  'coach.onboarding.task.assignPlan.cta': 'Asignar plan',

  'exercises.field.category': 'Categoría',
  'exercises.field.variant': 'Variante',
  'exercises.field.contractionType': 'Tipo de Contracción',
  'exercises.field.difficultyLevel': 'Dificultad',
  'exercises.field.movementPlane': 'Plano de Movimiento',
  'exercises.field.unilateralType': 'Tipo de Unilateral',
  'exercises.field.movementPattern': 'Patrón de Movimiento',
  'exercises.field.regressionExercise': 'Ejercicio de Regresión',
  'exercises.field.progressionExercise': 'Ejercicio de Progresión',
  'exercises.field.equipment': 'Equipamiento',
  'exercises.field.muscles': 'Músculos',
  'exercises.field.rpeMethod': 'Método de Medición Subjetiva',

  // Plan
  'plan.details': 'Detalles del Plan',
  'plans.name': 'Nombre',
  'plans.description': 'Descripción',
  'plans.isTemplate': 'Es Plantilla',
  'plans.makeTemplate': 'Hacer de este plan una plantilla',
  'plans.created': 'Creado',

  // Validation
  'validation.required': 'Este campo es obligatorio',

  // Añadir las siguientes traducciones en la sección de coach.home
  'coach.home.welcome': 'Bienvenido, {name}',
  'coach.home.today': 'Hoy',
  'coach.home.yesterday': 'Ayer',
  'coach.home.daysAgo': 'Hace {days} días',
  'coach.home.sessions': 'sesiones',
  'coach.home.quickActions': 'Acciones rápidas',
  'coach.home.createWorkout': 'Crear rutina',
  'coach.home.addExercise': 'Añadir ejercicio',
  'coach.home.viewProfile': 'Ver mi perfil',
  'coach.home.manageStudents': 'Gestionar alumnos',
  'coach.home.viewAll': 'Ver todos',
  'coach.home.noClientsData': 'No hay datos de clientes disponibles',
  'coach.home.table.last7days': 'Últimos 7 días',

  'common.inactive': 'Inactivo',

  // New training finish dialog translations
  'training.finish.title': 'Finalizar Entrenamiento',
  'training.finish.sessionDetails': 'Detalles de la Sesión',
  'training.finish.sessionTime': 'Tiempo de Sesión',
  'training.finish.sessionTime.placeholder': 'Ingresa la duración de tu sesión',
  'training.finish.generalFeedback': 'Comentarios Generales',
  'training.finish.generalFeedback.placeholder': '¿Cómo estuvo tu sesión de entrenamiento?',
  'training.finish.measurements': 'Mediciones',
  'training.finish.energyLevel.enable': 'Registrar Nivel de Energía',
  'training.finish.energyLevel': 'Nivel de Energía',
  'training.finish.low': 'Bajo',
  'training.finish.high': 'Alto',
  'training.finish.mood.enable': 'Registrar Estado de Ánimo',
  'training.finish.mood': 'Estado de Ánimo',
  'training.finish.bad': 'Malo',
  'training.finish.great': 'Excelente',
  'training.finish.difficulty.enable': 'Registrar Dificultad',
  'training.finish.difficulty': 'Dificultad Percibida',
  'training.finish.easy': 'Fácil',
  'training.finish.challenging': 'Desafiante',
  'training.finish.additionalNotes': 'Notas Adicionales',
  'training.finish.additionalNotes.placeholder': '¿Algo más que quieras anotar sobre esta sesión?',
  'training.markAllCompleted': 'Completar todo',
  'training.markAllSkipped': 'Saltar todo',
  'training.finish.incomplete': 'Incompleto',
  'training.finish.completeMeasurements': 'Completá los inputs de medición subjetiva para cada set antes de finalizar.',
  'training.confirm.title': '¿Lograste terminar todo?',
  'training.confirm.message': 'No marcaste todos los ejercicios. ¿Pudiste terminar todo?',
  'training.confirm.messagePartial':
    'No marcaste todos los sets. Podés guardar lo que hiciste (los sets sin marcar se guardan como no completados) o marcar todo como finalizado.',
  'training.confirm.savePartial': 'Guardar lo que hice',
  'training.confirm.markAllDone': 'Marcar todo como finalizado',
  'training.confirm.goBack': 'Volver a marcar lo que no logré hacer',

  'coach.exercise.upload.updated': 'Ejercicios actualizados',
  'exercise.exerciseType': 'Tipo de Ejercicio',

  cancel: 'Cancelar',
  submit: 'Enviar',

  // Assign Workout to Cycle Dialog
  'verification.title': 'Verificación de Correo',
  'verification.codePlaceholder': 'Ingresa el código de verificación',
  'verification.code': 'Código de verificación',
  'verification.verify': 'Verificar',
  'verification.success': '¡Correo verificado exitosamente!',
  'verification.error': 'Error al verificar el correo',
  'verification.error.invalidCode': 'Código de verificación inválido',
  'verification.error.codeRequired': 'Ingresa el código de verificación antes de continuar',
  'verification.resend': 'Reenviar código',
  'verification.message': 'Por favor ingresa el código de verificación enviado a {email}',
  'verification.exitConfirmation':
    '¿Estás seguro de que querés salir sin verificar tu cuenta? No podrás iniciar sesión hasta que verifiques tu correo.',

  'exercises.analysis.title': 'Análisis de Ejercicios',
  'exercises.analysis.summary': 'Resumen del Análisis',
  'exercises.analysis.total': 'Total de ejercicios: {total} (Nuevos: {new}, Existentes: {existing})',
  'exercises.analysis.skippedGlobal':
    '{n} ya existen en la biblioteca de TrainEase y no se importan (no se pueden editar).',
  'exercises.import.duplicatesInFile.title':
    'Se encontraron ejercicios con nombres duplicados en el archivo. Por favor corregí el archivo Excel y volvé a importarlo.',
  'exercises.import.duplicatesInFile.rows': 'filas {rows}',
  'exercises.import.previewVideo': 'Ver video',
  'exercises.name': 'Nombre',
  'exercises.status': 'Estado',
  'exercises.status.new': 'Nuevo',
  'exercises.status.existing': 'Existente',
  'exercises.currentData': 'Datos Actuales',
  'exercises.newData': 'Nuevos Datos',
  'exercises.changes': 'Cambios',
  'exercises.field.description': 'Descripción',
  'exercises.field.exerciseType': 'Tipo de Ejercicio',
  'exercises.field.equipmentNeeded': 'Equipo Necesario',
  'exercises.field.multimedia': 'Multimedia',

  'assignWorkout.error.workoutRequired': 'Elegí un entrenamiento para asignar.',
  'assignWorkout.error.sessionModeRequired': 'Elegí el tipo de entrenamiento.',
  'assignWorkout.title': 'Asignar Entrenamiento a Sesión',
  'assignWorkout.description': 'Selecciona un entrenamiento para asignar a la sesión',
  'assignWorkout.trainingType': 'Tipo de Entrenamiento',
  'assignWorkout.selectWorkout': 'Seleccionar Entrenamiento',
  'assignWorkout.selectWorkoutPlaceholder': 'Seleccionar un entrenamiento',
  'assignWorkout.selectDate': 'Seleccionar Fecha',
  'assignWorkout.selectDatePlaceholder': 'Seleccionar una fecha',
  'assignWorkout.selectTime': 'Seleccionar Hora',
  'assignWorkout.selectTimePlaceholder': 'Seleccionar una hora',
  'assignWorkout.selectRpeMethod': 'Método de Medición de Carga',
  'assignWorkout.selectRpeMethodPlaceholder': 'Seleccionar método RPE',
  'assignWorkout.rpeMethodInherit': 'Heredar de cada ejercicio',
  'assignWorkout.rpeMethodHelp':
    'Si lo dejás vacío, cada ejercicio usa el método configurado en su catálogo. Útil cuando querés mezclar RPE y RIR en una misma sesión.',
  'assignWorkout.error.rpeRequired': 'Por favor selecciona un método RPE',
  'assignWorkout.selectLocation': 'Seleccionar Ubicación',
  'assignWorkout.selectLocationPlaceholder': 'Seleccionar una ubicación',
  'assignWorkout.selectTrainingType': 'Seleccionar Tipo de Entrenamiento',
  'assignWorkout.selectTrainingTypePlaceholder': 'Seleccionar un tipo de entrenamiento',
  'assignWorkout.location': 'Ubicación',
  'assignWorkout.locationPlaceholder': 'Seleccionar una ubicación',
  'assignWorkout.sessionTime': 'Tiempo de Sesión',
  'assignWorkout.contactMethod': 'Método de Contacto',
  'assignWorkout.selectContactMethod': 'Seleccionar un método de contacto',
  'assignWorkout.assign': 'Asignar',
  'assignWorkout.createNewSession': 'Crear Nueva Sesión',
  'assignWorkout.meetingLink': 'Enlace de Reunión',
  'assignWorkout.meetingLinkPlaceholder': 'Ingresa el enlace de la reunión',
  'dashboard.calendar.joinMeeting': 'Unirse a la Reunión',
  'dashboard.calendar.startTrainingSession': 'Iniciar Entrenamiento',

  'student.sessionMode': 'Modo de Sesión',
  'student.selectSessionMode': 'Seleccionar un modo de sesión',
  'student.selectTrainingType': 'Seleccionar un tipo de entrenamiento',
  'student.contactMethod': 'Método de Contacto',
  'student.selectContactMethod': 'Seleccionar un método de contacto',
  'student.location': 'Ubicación',
  'student.locationPlaceholder': 'Seleccionar una ubicación',

  // Mercado Pago
  'payment.method.mercadoPago': 'Mercado Pago',
  'payment.method.bankTransfer': 'Transferencia Bancaria',
  'payment.mercadoPagoDetails': 'Detalles de Mercado Pago',
  'payment.bankTransferDetails': 'Detalles de Transferencia Bancaria',
  'payment.success.bankDataUpdated': 'Datos bancarios actualizados exitosamente',
  'error.updatingBankData': 'Error al actualizar los datos bancarios',
  'error.fetchingBankData': 'Error al obtener los datos bancarios',
  'payment.bankData': 'Datos Bancarios',
  'payment.process': 'Procesar Pago',
  'payment.makePayment': 'Realizar Pago',
  'payment.method': 'Método de Pago',
  'payment.selectMethod': 'Seleccionar Método de Pago',
  'payment.title': 'Pago de Suscripción',
  'payment.amount': 'Monto',
  'payment.mercadoPago': 'Mercado Pago',
  'payment.bankTransfer': 'Transferencia Bancaria',
  'payment.accountType.savings': 'Cuenta de Ahorro',
  'payment.accountType.checking': 'Cuenta Corriente',
  'payment.mercadoPagoDescription':
    'Realiza el pago directamente a través de Mercado Pago. Serás redirigido a la página de pago segura.',
  'payment.bankTransferDescription':
    'Realiza una transferencia bancaria y notifica al coach. El coach verificará el pago y actualizará tu suscripción.',
  'payment.startDate': 'Fecha de Inicio',
  'payment.endDate': 'Fecha de Fin',
  'payment.paymentDate': 'Fecha de Pago',
  'payment.transferDate': 'Fecha de Transferencia',
  'payment.selectPlan': 'Seleccionar Plan',
  'payment.transferAmount': 'Monto de Transferencia',
  'payment.transferReference': 'Referencia de Transferencia',
  'payment.enterAmount': 'Ingresar Monto',
  'payment.enterReference': 'Ingresar Referencia',
  'payment.payWithMercadoPago': 'Pagar con Mercado Pago',
  'payment.notifyTransfer': 'Notificar Transferencia',
  'payment.redirecting': 'Redirigiendo a Mercado Pago...',
  'payment.wait': 'Por favor espera...',
  'payment.coachBankData': 'Datos Bancarios del Coach',
  'payment.bankName': 'Banco',
  'payment.accountType': 'Tipo de Cuenta',
  'payment.accountNumber': 'Número de Cuenta',
  'payment.cbu': 'CBU',
  'payment.alias': 'Alias',
  'payment.noBankData': 'El coach no ha proporcionado datos bancarios.',
  'payment.success.paymentApproved': 'Pago aprobado exitosamente',
  'payment.success.paymentRegistered': 'Pago registrado y suscripción actualizada exitosamente',
  'payment.success.transferNotified': 'Notificación de transferencia enviada al coach',
  'payment.error.paymentRejected': 'Pago rechazado',
  'payment.error.selectPaymentDate': 'Por favor selecciona una fecha de pago',
  'payment.error.selectPlan': 'Por favor selecciona un plan',
  'payment.error.enterTransferReference': 'Por favor ingresa una referencia para la transferencia',
  'payment.error.enterTransferAmount': 'Por favor ingresa el monto de la transferencia',
  'payment.error.enterAmount': 'Por favor ingresa un monto válido',
  'registerPayment.preview':
    'Se registrarán {periods, plural, one {# período} other {# períodos}}. Nueva fecha de fin: {endDate}.',
  'payment.mercadoPagoAccessToken': 'Token de Mercado Pago',
  'payment.mercadoPagoPublicKey': 'Clave Pública de Mercado Pago',
  'payment.mercadoPagoUserId': 'ID de Usuario de Mercado Pago',
  'coach.importExercises.help.title': 'Importar ejercicios desde Excel',
  'coach.importExercises.help.intro':
    'Tu archivo Excel puede incluir estas columnas. Descargá la plantilla: trae ejemplos cargados y una segunda hoja con todos los valores que acepta cada columna.',
  'coach.importExercises.help.downloadTemplate': 'Descargar plantilla',
  'coach.importExercises.help.chooseFile': 'Seleccionar archivo',
  'coach.importExercises.help.table.column': 'Columna',
  'coach.importExercises.help.table.description': 'Descripción',
  'coach.importExercises.help.table.required': 'Requerido',
  'coach.importExercises.help.col.name': 'Nombre del ejercicio (único)',
  'coach.importExercises.help.col.description': 'Descripción o técnica',
  'coach.importExercises.help.col.videoUrl': 'URL del video (YouTube)',
  'coach.importExercises.help.col.category_id': 'Categoría (nombre o ID)',
  'coach.importExercises.help.col.variant_id': 'Variante (nombre o ID)',
  'coach.importExercises.help.col.contraction_id': 'Tipo de contracción (nombre o ID)',
  'coach.importExercises.help.col.difficulty_id': 'Nivel de dificultad (nombre o ID)',
  'coach.importExercises.help.col.movement_plane_id': 'Plano de movimiento (nombre o ID)',
  'coach.importExercises.help.col.measurement_method_id': 'Método de medición: RPE 1-10 o RIR 0-5',
  'coach.importExercises.help.col.unilateral_id': 'Unilateral o bilateral (nombre o ID)',
  'coach.importExercises.help.col.movement_pattern_id': 'Patrón de movimiento (nombre o ID)',
  'coach.importExercises.help.col.equipment_ids': 'Equipamiento, separado por comas (nombre o ID)',
  'coach.importExercises.help.col.muscle_ids': 'Músculos, separados por comas (nombre o ID)',
  'coach.importExercises.help.col.regression_exercise_id': 'Ejercicio de regresión (nombre o ID)',
  'coach.importExercises.help.col.progression_exercise_id': 'Ejercicio de progresión (nombre o ID)',
  'coach.importExercises.help.header.name': 'Nombre del ejercicio',
  'coach.importExercises.help.header.videoUrl': 'Video (YouTube)',
  'coach.importExercises.help.header.category_id': 'Categoría',
  'coach.importExercises.help.header.variant_id': 'Variante',
  'coach.importExercises.help.header.contraction_id': 'Tipo de contracción',
  'coach.importExercises.help.header.difficulty_id': 'Dificultad',
  'coach.importExercises.help.header.movement_plane_id': 'Plano de movimiento',
  'coach.importExercises.help.header.measurement_method_id': 'Método de medición (RPE o RIR)',
  'coach.importExercises.help.header.unilateral_id': 'Unilateral o bilateral',
  'coach.importExercises.help.header.movement_pattern_id': 'Patrón de movimiento',
  'coach.importExercises.help.header.equipment_ids': 'Equipamiento necesario',
  'coach.importExercises.help.header.muscle_ids': 'Músculos involucrados',
  'coach.importExercises.help.header.regression_exercise_id': 'Ejercicio de regresión',
  'coach.importExercises.help.header.progression_exercise_id': 'Ejercicio de progresión',
  'coach.importExercises.help.sheet.values.id': 'id',
  'coach.importExercises.help.sheet.values.name': 'nombre',
  'coach.importExercises.help.sheet.values.multi': 'varios, separados por coma',
  'coach.importExercises.help.sheet.exercises': 'Ejercicios',
  'coach.importExercises.help.sheet.values': 'Valores aceptados',
  'coach.importExercises.help.sheet.values.column': 'Columna',
  'coach.importExercises.help.sheet.values.value': 'Valor aceptado',
  'coach.importExercises.help.templatePartial.title': 'Plantilla incompleta',
  'coach.importExercises.help.templatePartial':
    'No se pudieron traer los valores de tu catálogo. La plantilla se descargó igual, pero con nombres de ejemplo que quizá no coincidan con tu base.',
  'coach.importExercises.help.templateError.title': 'No se pudo generar la plantilla',
  'coach.importExercises.map.title': 'Asociá las columnas de tu archivo',
  'coach.importExercises.map.intro':
    'Detectamos estas columnas en tu archivo. Las que coinciden ya las asociamos automáticamente; revisá el resto y elegí a qué campo corresponde cada una. Solo el nombre es obligatorio.',
  'coach.importExercises.map.none': '— No importar —',
  'coach.importExercises.map.required': 'Asociá al menos una columna al campo Nombre para continuar.',
  'coach.importExercises.map.confirm': 'Continuar',
  'coach.importExercises.map.detectedColumns': '{n} columnas detectadas',
  'coach.importExercises.map.autoMatched': '{n} asociadas automáticamente',
  'coach.importExercises.map.fileColumn': 'Columna de tu archivo',
  'coach.importExercises.map.modelField': 'Campo de TrainEase',
  'coach.importExercises.map.noColumns':
    'No se detectaron columnas en el archivo. Revisá que tenga una fila de encabezados.',
  // Import workout via AI (coach flow)
  'coach.importWorkoutAI.title': 'Importar workout con IA',
  'coach.importWorkoutAI.intro':
    'Subí una foto del Excel o pizarrón, un archivo .xlsx/.csv, o pegá el texto del entrenamiento. La IA detecta los grupos y matchea los ejercicios contra tu catálogo.',
  'coach.importWorkoutAI.tab.file': 'Archivo',
  'coach.importWorkoutAI.tab.text': 'Texto',
  'coach.importWorkoutAI.dropHint': 'Seleccioná un archivo para parsear',
  'coach.importWorkoutAI.formats': 'JPG · PNG · WebP · XLSX · CSV (máx. 10 MB)',
  'coach.importWorkoutAI.chooseFile': 'Elegir archivo',
  'coach.importWorkoutAI.changeFile': 'Cambiar archivo',
  'coach.importWorkoutAI.parseAction': 'Parsear con IA',
  'coach.importWorkoutAI.parsing': 'Parseando el workout — esto puede tardar unos segundos…',
  'coach.importWorkoutAI.textPlaceholder':
    'Ej: Press plano | Media | 4x8\\nSentadilla profunda | Liviana | 8.0\\nPlancha lateral | - | 30 segundos',
  'coach.importWorkoutAI.entryButton': 'Importar con IA',
  // Import CICLO via AI (multi-día batch)
  'coach.importCycleAI.title': 'Importar ciclo con IA',
  'coach.importCycleAI.intro':
    'Subí una planificación entera (foto, .xlsx, .csv, texto). La IA detecta hasta 7 días y matchea los ejercicios. Después confirmás y se crea un ciclo con N workouts.',
  'coach.importCycleAI.weeklyWarning':
    'La IA solo captura la Semana 1. Las progresiones de carga (Semana 2/3/4…) se editan después manualmente.',
  'coach.importCycleAI.parseAction': 'Parsear ciclo con IA',
  'coach.importCycleAI.parsing': 'Parseando la planificación — esto puede tardar varios segundos…',
  'coach.importCycleAI.textPlaceholder':
    'Pegá la planificación entera (multi-día). Ej:\\n\\nDía 1 - E. Tracción\\nA1. Pull Ups | 3 | 6 a 8 | 22kg\\nA2. Plancha alejada | | 20 a 40" | -\\n\\nDía 2 - Empuje\\n…',
  'coach.importCycleAI.cycleName': 'Nombre del ciclo',
  'coach.importCycleAI.weeks': 'Semanas',
  'coach.importCycleAI.empty': 'Sin días detectados. Eliminá el preview y volvé a parsear.',
  'coach.importCycleAI.createAction': 'Crear ciclo + {count} workout(s)',
  'coach.importCycleAI.entryButton': 'Importar con IA',
  // Quick create exercise (inline + header button)
  'coach.quickCreateExercise.title': 'Nuevo ejercicio',
  'coach.quickCreateExercise.intro':
    'Creá un ejercicio mínimo con solo el nombre. Lo podés enriquecer después desde la biblioteca de ejercicios.',
  'coach.quickCreateExercise.name': 'Nombre',
  'coach.quickCreateExercise.placeholder': 'Ej: Press inclinado con mancuernas',
  'coach.quickCreateExercise.create': 'Crear',
  'coach.quickCreateExercise.headerButton': 'Agregar ejercicio',
  // Drafts (localStorage, max 3)
  'coach.drafts.saveButton': 'Guardar borrador',
  'coach.drafts.button': 'Borradores ({count}/{max})',
  'coach.drafts.heading': 'Borradores guardados localmente',
  'coach.drafts.continue': 'Continuar este borrador',
  'coach.drafts.delete': 'Descartar borrador',
  'coach.drafts.newBlank': 'Nuevo workout en blanco',
  'coach.drafts.untitled': 'Sin nombre',
  'coach.drafts.groupsCount': '{count, plural, one {# grupo} other {# grupos}}',
  'coach.drafts.justNow': 'hace instantes',
  'coach.drafts.savedToast': 'Borrador guardado',
  'coach.drafts.savedDetail': 'Lo podés recuperar desde "Borradores"',
  'coach.drafts.loadedToast': 'Borrador cargado',
  'coach.drafts.deletedToast': 'Borrador descartado',
  'coach.exercise.titleSingular': 'Ejercicio',
  'coach.rpe.assign.title': 'Asignar Método RPE',
  'coach.rpe.assign.step1': 'Seleccionar tipo',
  'coach.rpe.assign.step2': 'Seleccionar objetivo',
  'coach.rpe.assign.step3': 'Seleccionar método RPE',
  'coach.rpe.assign.summary': 'Resumen de asignación',
  'coach.rpe.assign.target': 'Objetivo',
  'coach.rpe.isDefault': 'Método por defecto',

  // v2 web redesign — design handoff §8
  'setConfig.bulk.copyFirstToAll': 'Copiar set 1 a todos',
  'setConfig.bulk.progressive': 'Set progresivo +2.5kg',
  'setConfig.bulk.reset': 'Restablecer',
  'setConfig.column.applyToAll': 'Aplicar a todos',
  'setConfig.columns.label': 'Columnas',
  'cycle.wizard.step.start': 'Inicio',
  'cycle.wizard.step.data': 'Datos',
  'cycle.wizard.step.assign': 'Asignar workouts',
  'cycle.wizard.fromScratch.title': 'Desde cero',
  'cycle.wizard.fromScratch.desc': 'Definí duración y qué workout va cada día.',
  'cycle.wizard.fromPreviousCycle.title': 'Desde un ciclo anterior',
  'cycle.wizard.fromPreviousCycle.desc':
    'Arrancá desde donde quedó: copia una semana de un ciclo previo de este alumno, con las cargas que le veniste subiendo.',
  'cycle.wizard.fromPreviousCycle.pickCycle': '¿De qué ciclo lo copiamos?',
  'cycle.wizard.fromPreviousCycle.pickCyclePlaceholder': 'Elegí un ciclo anterior',
  'cycle.wizard.fromPreviousCycle.pickWeek': '¿Qué semana tomamos como base?',
  'cycle.wizard.fromPreviousCycle.weekSummary': 'Se copian {n} días con entrenamiento a cada semana del ciclo nuevo.',
  'cycle.wizard.fromPreviousCycle.emptyWeek': 'Esta semana no tiene entrenamientos cargados',
  'cycle.wizard.fromPreviousCycle.empty': 'Este alumno todavía no tiene ciclos con entrenamientos cargados',
  'cycle.wizard.fromPreviousCycle.success': 'Ciclo creado a partir de la semana elegida',
  'cycle.wizard.fromTemplate.title': 'Desde plantilla',
  'cycle.wizard.fromTemplate.desc': 'Usá un ciclo previamente armado.',
  'cycle.weekGrid.applyToAllWeeks': 'Replicar a las {n} semanas',
  'cycle.weekGrid.dropHere': 'Soltar aquí',
  'cycle.weekGrid.weekN': 'Sem {n}',
  'weekGrid.availableSessions': 'Sesiones disponibles',
  'weekGrid.noWorkouts': 'No hay sesiones disponibles',
  'weekGrid.replicateToAll': 'Replicar a las {n} semanas',
  'weekGrid.replicateDesc': 'Lo que armás en la semana 1 se copia al resto.',
  'weekGrid.week': 'Semana',
  'weekGrid.sessionsPerWeek': 'sesiones/semana',
  'weekGrid.totalSessions': 'total de sesiones',
  'weekGrid.restDays': 'días de descanso',
  'calendar.action.programar': 'Programar',
  'calendar.action.onActiveCycle': 'Sobre ciclo activo',
  'calendar.action.newCycle': 'Nuevo ciclo',
  'calendar.action.addSessions': 'Agregar sesiones',
  'calendar.action.removeSessions': 'Quitar sesiones',
  'calendar.activeCycle.label': 'Ciclo activo · {name}',
  'session.quickComplete.hint': 'Tocá un RPE y guardamos el set con el plan.',
  'session.quickComplete.required': 'REQUERIDO',
  'session.quickComplete.customize': 'Personalizar',
  'session.quickComplete.resetPlan': 'Restablecer plan',
  'session.skip': 'Saltar set',
  'session.rpe.label': '¿Cuánto te costó?',
  'session.compare.last': 'Última: {reps}×{weight}kg @ RPE {rpe}',
  'session.compare.target': '+{delta} kg objetivo',
  'excelView.title': 'Vista Excel',
  'excelView.empty': 'Este cliente no tiene un ciclo activo',
  'excelView.bulk.autoProgression': 'Auto-progresión (+2.5kg/sem)',
  'excelView.bulk.copyColumn': 'Copiar columna →',
  'excelView.legend.currentWeek': 'Semana actual',
  'excelView.legend.pr': 'PR proyectado',
  'excelView.legend.deload': 'Deload',
  'planEditor.adaptive.extraColumns': '+{n} columnas personalizadas',

  // v2 Excel view extras
  'excelView.bulk.duplicateWeek': 'Duplicar semana',
  'excelView.bulk.autoProgression.confirm':
    'Esto va a sumar {stepKg} kg cada semana a todas las celdas con peso. ¿Confirmás?',
  'excelView.bulk.copyColumn.confirm': '¿Copiar los valores de Semana {src} a Semana {dst}?',
  'excelView.bulk.duplicateWeek.confirm':
    '¿Duplicar Semana {n}? Se va a agregar una nueva semana inmediatamente después.',
  'excelView.bulk.duplicateWeek.success': 'Semana duplicada.',
  'excelView.bulk.applied': '{n} celdas actualizadas.',
  'excelView.bulk.noChanges': 'No hay cambios para aplicar.',
  'excelView.cell.empty': 'Sin sesión planificada esta semana',
  'excelView.cell.sets': '{n} sets',
  'excelView.col.exercise': 'Ejercicio',
  'excelView.col.sets': 'Sets',
  'excelView.col.copyHint': 'Click para copiar a la siguiente semana',
  'excelView.selectCycle': 'Seleccionar ciclo',
  'excelView.noSessions': 'Este ciclo no tiene sesiones asignadas todavía.',
  'common.refresh': 'Refrescar',
  'common.retry': 'Reintentar',
  'common.info': 'Info'
};
export default messages;
